<section
  class="dvm-layout-builder-workspace"
  [class.steps-panel-collapsed]="stepsPanelCollapsed"
  [class.preview-panel-collapsed]="previewPanelCollapsed"
  [class.data-panel-collapsed]="dataPanelCollapsed"
  [style.--steps-pane-width.px]="stepsPaneWidth"
  [style.--data-pane-width.px]="dataPaneWidth"
  [style.grid-template-columns]="paneGridTemplate"
>
  <!-- ══════════════════ LEFT: configuration panel ══════════════════ -->
  <aside class="dvm-layout-target-panel wf-section" *ngIf="false">
      <header class="wf-section-header">
        <div><span class="wf-section-kicker">01 · Setup</span><h3>Target chart</h3></div>
        <button
          type="button"
          class="panel-collapse-button"
          mat-icon-button
          (click)="targetPanelCollapsed = !targetPanelCollapsed"
          [matTooltip]="targetPanelCollapsed ? 'Open target chart' : 'Collapse target chart'"
          [attr.aria-label]="targetPanelCollapsed ? 'Open target chart panel' : 'Collapse target chart panel'"
        ><mat-icon>{{ targetPanelCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon></button>
      </header>
      <div class="panel-content">
      <div class="control-row">
        <div class="control-group">
          <label for="wfLayoutType">Chart layout</label>
          <ng-select
            labelForId="wfLayoutType"
            #ssWfLayout
            class="ss-select"
            [class.is-open]="!!ssWfLayout.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="layoutTypes"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngModel]="selectedLayoutType"
            (ngModelChange)="selectedLayoutType = $event; onLayoutTypeChange()"
          ></ng-select>
        </div>
        <div class="control-group">
          <label for="wfTitle">Title</label>
          <input
            id="wfTitle"
            type="text"
            [(ngModel)]="title"
            placeholder="e.g. Gross Revenue to Net Profit Multi-Bridge"
          />
        </div>
      </div>

      <div class="control-row">
        <div class="control-group">
          <label for="wfComponentId">Component Id</label>
          <input id="wfComponentId" type="text" [(ngModel)]="componentId" />
        </div>
        <div class="control-group">
          <label for="wfDashboardId">Dashboard Id</label>
          <input id="wfDashboardId" type="number" [(ngModel)]="dashboardId" />
        </div>
      </div>

      <div class="control-group control-group-full">
        <label for="wfDatasets">Datasets</label>
        <ng-select
          labelForId="wfDatasets"
          #ssWfDatasets
          class="ss-select ss-select--multi ss-select--full"
          [class.is-open]="!!ssWfDatasets.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="entityOptions"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [loading]="entitiesLoading"
          [clearable]="true"
          [searchable]="true"
          placeholder="Select one or more operational data tables/entities"
          [ngModel]="selectedDatasets"
          (ngModelChange)="onSelectedDatasetsChange($event)"
        ></ng-select>
        <small class="control-hint" *ngIf="!selectedDatasets.length">Pick at least one dataset before adding steps.</small>
      </div>
      </div>
  </aside>

  <div class="pane-resizer target-pane-resizer" aria-hidden="true"></div>

  <aside class="dvm-layout-steps-panel wf-section wf-steps-section" [class.is-collapsed]="stepsPanelCollapsed" [style.grid-column]="paneGridColumn('steps')" (dragover)="onPaneDragOver($event)" (drop)="onPaneDrop('steps', $event)">
      <header class="wf-section-header wf-steps-head pane-drag-handle" draggable="true" (dragstart)="onPaneDragStart('steps', $event)" (dragend)="onPaneDragEnd()" matTooltip="Drag to reorder panel">
        <div><span class="wf-section-kicker">Build</span><h3>{{ buildPanelTitle }} <span class="wf-step-count" *ngIf="buildPanelCount !== null">{{ buildPanelCount }}</span></h3></div>
        <div class="wf-header-actions">
          <button *ngIf="isWaterfallLayout" type="button" class="add-step-button" mat-stroked-button (click)="addStep()"><mat-icon>add</mat-icon> Add step</button>
          <button
            type="button"
            class="panel-collapse-button"
            mat-icon-button
            (click)="stepsPanelCollapsed = !stepsPanelCollapsed"
            [matTooltip]="stepsPanelCollapsed ? 'Open bridge steps' : 'Collapse bridge steps'"
            [attr.aria-label]="stepsPanelCollapsed ? 'Open bridge steps panel' : 'Collapse bridge steps panel'"
          ><mat-icon>{{ paneCollapseIcon('steps') }}</mat-icon></button>
        </div>
      </header>
      <div class="panel-content steps-panel-content">

      <div class="bridge-chart-settings">
        <div class="bridge-settings-heading"><mat-icon>tune</mat-icon><span>{{ layoutSectionTitle('config', 'Chart configuration') }}</span></div>

        <!-- LAYER 1 — Chart Catalogue: Category → Type. The Category picker shows
             only when a catalogue is configured; it filters the Type list below. -->
        <div class="control-group" *ngIf="hasChartCatalogue">
          <label for="bridgeChartCategory">Chart category</label>
          <ng-select
            labelForId="bridgeChartCategory"
            #ssBridgeCategory
            class="ss-select"
            [class.is-open]="!!ssBridgeCategory.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="chartCategories"
            bindLabel="label"
            bindValue="id"
            [clearable]="false"
            [ngModel]="selectedChartCategory"
            (ngModelChange)="selectedChartCategory = $event; onChartCategoryChange()"
          ></ng-select>
        </div>

        <div class="control-group">
          <label for="bridgeLayoutType">{{ hasChartCatalogue ? 'Chart type' : 'Chart layout' }}</label>
          <ng-select
            labelForId="bridgeLayoutType"
            #ssBridgeLayout
            class="ss-select"
            [class.is-open]="!!ssBridgeLayout.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="hasChartCatalogue ? typesForSelectedCategory : layoutTypes"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngModel]="selectedLayoutType"
            (ngModelChange)="selectedLayoutType = $event; onLayoutTypeChange()"
          ></ng-select>
        </div>
        <!-- Title moved into its own 'Title' accordion (Bar & Waterfall layouts).
             For the remaining layouts (kpi/drill-down/…) keep the inline Title
             field here; config-driven — a layout's config section listing
             `title` in its fields shows it, omitting it hides it. -->
        <!-- Bar / Line & Area / Drill-Down surface their Title via a 'Title' format
             accordion, so exclude the inline field for them. -->
        <div class="control-group" *ngIf="!isBarLayout && !isLineAreaLayout && !(isTableMatrixLayout && isTmDrilldown) && fieldEnabled('config', 'title')">
          <label for="bridgeTitle">Title</label>
          <input id="bridgeTitle" type="text" [(ngModel)]="title" placeholder="e.g. Gross Revenue to Net Profit" />
        </div>
        <!-- <div class="selected-data-summary">
          <mat-icon>database</mat-icon>
          <span>{{ selectedDatasets.length ? selectedDatasets.length + ' table(s) selected' : 'Drag a field from the Data pane to select a table' }}</span>
        </div> -->
      </div>

      <ng-container *ngIf="isWaterfallLayout">
        <div class="wf-empty" *ngIf="!steps.length">
          No steps yet - add a Start step to anchor the bridge, then Change/Total steps to build it out.
        </div>

        <div class="wf-step-card" *ngFor="let step of steps; let i = index; let first = first; let last = last">
          <div class="wf-step-head">
            <span class="wf-step-index">{{ i + 1 }}</span>

            <ng-select
              #ssWfStepType
              class="ss-select wf-step-type-select"
              [class.is-open]="!!ssWfStepType.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="stepTypes"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [ngModel]="step.stepType"
              (ngModelChange)="step.stepType = $event; onStepTypeChange(step)"
            ></ng-select>

            <input
              type="text"
              class="wf-step-label"
              [ngModel]="step.label"
              (ngModelChange)="step.label = $event; onStepFormulaOrLabelChange()"
              placeholder="Display label"
            />


            <div class="wf-step-actions">
              <button type="button" mat-icon-button [disabled]="first" (click)="moveStepUp(i)" matTooltip="Move up" aria-label="Move step up">
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <button type="button" mat-icon-button [disabled]="last" (click)="moveStepDown(i)" matTooltip="Move down" aria-label="Move step down">
                <mat-icon>arrow_downward</mat-icon>
              </button>
              <button type="button" mat-icon-button class="row-remove-button" (click)="removeStep(step)" matTooltip="Remove step" aria-label="Remove step">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <div class="wf-step-mode-toggle" *ngIf="step.stepType === 'CHANGE' || step.stepType === 'START'" role="group" aria-label="Step input mode">
            <button type="button" [class.is-active]="!step.formulaMode" (click)="step.formulaMode ? toggleStepFormulaMode(step) : null">
              <mat-icon>table_chart</mat-icon>
              Dataset
            </button>
            <button type="button" [class.is-active]="step.formulaMode" (click)="!step.formulaMode ? toggleStepFormulaMode(step) : null">
              <mat-icon>functions</mat-icon>
              Formula
            </button>
          </div>

          <!-- Direction applies to a CHANGE step's own delta/bar regardless of
               whether its value comes from a dataset aggregation or a formula,
               so it's shown for both modes (moved out of the dataset-only body
               below, which used to hide it whenever Formula mode was active). -->
          <div class="wf-step-body" *ngIf="step.stepType === 'CHANGE' && fieldEnabled('steps', 'sign')">
            <div class="control-group">
              <label>{{ fieldLabel('steps', 'sign', 'Direction') }}</label>
              <ng-select
                #ssWfSignShared
                class="ss-select"
                [class.is-open]="!!ssWfSignShared.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="signOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [ngModel]="step.sign"
                (ngModelChange)="step.sign = $event; onStepFormulaOrLabelChange()"
              ></ng-select>
            </div>
          </div>

          <div
            class="wf-step-body wf-field-drop-zone"
            *ngIf="step.stepType !== 'TOTAL' && !step.formulaMode"
            (dragover)="allowFieldDrop($event)"
            (drop)="onStepFieldDrop($event, step)"
            title="Drop a field from the Data pane"
          >
            <div class="control-group" *ngIf="fieldEnabled('steps', 'dataset')">
              <label>{{ fieldLabel('steps', 'dataset', 'Dataset') }}</label>
              <ng-select
                #ssWfDataset
                class="ss-select"
                [class.is-open]="!!ssWfDataset.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="entityOptions"
                [clearable]="false"
                [ngModel]="step.dataset"
                (ngModelChange)="onStepDatasetChange(step, $event)"
              ></ng-select>
            </div>
            <div class="control-group" *ngIf="fieldEnabled('steps', 'field')">
              <label>{{ fieldLabel('steps', 'field', 'Field') }}</label>
              <ng-select
                #ssWfField
                class="ss-select"
                [class.is-open]="!!ssWfField.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="columnsForStep(step)"
                [clearable]="false"
                [searchable]="true"
                [loading]="isStepColumnsLoading(step)"
                [placeholder]="stepFieldPlaceholder(step)"
                [ngModel]="step.field || null"
                (ngModelChange)="onStepFieldChange(step, $event)"
              ></ng-select>
            </div>
            <div class="control-group" *ngIf="fieldEnabled('steps', 'aggregation')">
              <label>{{ fieldLabel('steps', 'aggregation', 'Aggregation') }}</label>
              <ng-select
                #ssWfAgg
                class="ss-select"
                [class.is-open]="!!ssWfAgg.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="measureAggregations"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [ngModel]="step.aggregation"
                (ngModelChange)="step.aggregation = $event; onStepFormulaOrLabelChange()"
              ></ng-select>
            </div>
          </div>

          <div class="wf-step-body" *ngIf="(step.stepType === 'TOTAL' || step.formulaMode) && fieldEnabled('steps', 'formula')">
            <div
              class="control-group control-group-full wf-field-drop-zone"
              (dragover)="allowFieldDrop($event)"
              (drop)="onWaterfallFormulaDrop(step, $event)"
              title="Drag a column here to add it to the formula"
            >
              <label>{{ fieldLabel('steps', 'formula', 'Calculation logic / formula') }}</label>
              <input
                type="text"
                [ngModel]="step.formula"
                (ngModelChange)="step.formula = $event; onStepFormulaOrLabelChange()"
                placeholder="Drag columns here, e.g. [Gross Revenue] + [Product Sales] - [COGS]"
              />
            </div>
          </div>
        </div>

        <!-- Waterfall chart options — the SAME config-driven format accordions as
             the Bar layout (Title / Axis / Legend / Labels / Tooltip / Formatting /
             Advanced), fed by the WATERFALL-scoped formatControls in
             charts/waterfall.json and gated by the capabilityRegistry `sections`
             list; the values fold into the tile on Generate. -->
        <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
      </ng-container>

      <!-- ══ Table & Matrix: config-driven type picker + per-type fields ══ -->
      <div class="table-matrix-config" *ngIf="isTableMatrixLayout">
        <div class="control-group">
          <label>{{ fieldLabel('tableMatrix', 'tableType', 'Table type') }}</label>
          <ng-select
            #ssTmType
            class="ss-select"
            [class.is-open]="!!ssTmType.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="tableTypes"
            bindLabel="label"
            bindValue="value"
            groupBy="group"
            [clearable]="false"
            [ngModel]="tmType"
            (ngModelChange)="tmType = $event; onTableMatrixTypeChange()"
          ></ng-select>
          <small class="control-hint" *ngIf="tmTypeHint">{{ tmTypeHint }}</small>
        </div>

        <!-- Dataset — declared (required) in charts/table-matrix.json's config
             section but previously never rendered in this form: the only picker
             lived in the collapsible target/data panel, so skipping that panel
             left Generate permanently disabled (and Drill-Down's pickers
             disabled with it). Single-select: the table renders from ONE
             dataset (drillDataset = first of selectedDatasets). -->
        <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

        <!-- Normal / Editable / Grouped / Tree / Financial: choose columns (empty = all).
             One row per column — each with its OWN dataset picker so a table can
             mix columns from different datasets ({dataset, field, displayName}
             in the compute payload). Dataset defaults to the primary one above. -->
        <ng-container *ngIf="isTmNormal || isTmEditable || isTmGrouped || isTmTreegrid || isTmFinancial">
          <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onTmColumnFieldDrop($event)" title="Drag columns here (leave empty to show every column)">
            <label>{{ fieldLabel('tableMatrix', 'columns', 'Columns') }}</label>
            <small class="control-hint" *ngIf="!tmColumns.length">
              No columns picked — the table shows every column of the primary dataset. Add rows to pick specific columns (from any dataset) and rename their headers.
            </small>

            <div class="tm-column-list" *ngIf="tmColumns.length">
              <div class="tm-column-card" *ngFor="let column of tmColumns; let i = index">
                <div class="tm-column-card-head">
                  <span class="wf-step-index">{{ i + 1 }}</span>
                  <span class="tm-column-card-title">{{ column.displayName || column.field || 'New column' }}</span>
                  <button type="button" mat-icon-button class="row-remove-button" (click)="removeTmColumn(column)" matTooltip="Remove column" aria-label="Remove column">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="tm-column-card-body">
                  <div class="control-group">
                    <label>Dataset</label>
                    <ng-select
                      #ssTmColDataset
                      class="ss-select"
                      [class.is-open]="!!ssTmColDataset.isOpen?.()"
                      appendTo="body"
                      ngClass="ss-dropdown-panel"
                      [items]="entityOptions"
                      [loading]="entitiesLoading"
                      [clearable]="false"
                      [searchable]="true"
                      placeholder="Same as primary"
                      [ngModel]="column.dataset || drillDataset || null"
                      (ngModelChange)="onTmColumnDatasetChange(column, $event)"
                    ></ng-select>
                  </div>
                  <div class="control-group">
                    <label>Column</label>
                    <ng-select
                      #ssTmColField
                      class="ss-select"
                      [class.is-open]="!!ssTmColField.isOpen?.()"
                      appendTo="body"
                      ngClass="ss-dropdown-panel"
                      [items]="columnsForTmColumn(column)"
                      [clearable]="true"
                      [searchable]="true"
                      [loading]="isTmColumnLoading(column)"
                      [placeholder]="tmColumnFieldPlaceholder(column)"
                      [ngModel]="column.field || null"
                      (ngModelChange)="onTmColumnFieldChange(column, $event)"
                    ></ng-select>
                  </div>
                  <div class="control-group">
                    <label>Display name</label>
                    <input
                      type="text"
                      [ngModel]="column.displayName"
                      (ngModelChange)="onTmColumnDisplayNameChange(column, $event)"
                      placeholder="Header label"
                    />
                  </div>
                </div>

                <!-- Default filter attached to THIS column's row — applied on the
                     table's FIRST data request, before any global filter. "Filter
                     column" defaults to this row's own column but can be pointed
                     at ANY other column (e.g. attach a rule_categories filter to
                     the Rule Name row even though rule_categories isn't itself
                     displayed). Blank value = no filter for this row. -->
                <div class="tm-column-card-body tm-column-filter-row">
                  <div class="control-group">
                    <label>Filter column</label>
                    <ng-select
                      #ssTmColFilterField
                      class="ss-select"
                      [class.is-open]="!!ssTmColFilterField.isOpen?.()"
                      appendTo="body"
                      ngClass="ss-dropdown-panel"
                      [items]="columnsForTmColumn(column)"
                      [clearable]="true"
                      [searchable]="true"
                      [loading]="isTmColumnLoading(column)"
                      [placeholder]="column.field || 'Same as this column'"
                      [ngModel]="column.filterField || null"
                      (ngModelChange)="onTmColumnFilterFieldChange(column, $event)"
                    ></ng-select>
                  </div>
                  <div class="control-group">
                    <label>Operator</label>
                    <ng-select
                      #ssTmColFilterOp
                      class="ss-select"
                      [class.is-open]="!!ssTmColFilterOp.isOpen?.()"
                      appendTo="body"
                      ngClass="ss-dropdown-panel"
                      [items]="tmInitialFilterOperators"
                      bindLabel="label"
                      bindValue="value"
                      [clearable]="false"
                      [ngModel]="column.filterOperator"
                      (ngModelChange)="onTmColumnFilterOperatorChange(column, $event)"
                    ></ng-select>
                  </div>
                  <div class="control-group">
                    <label>Value</label>
                    <input
                      type="text"
                      [ngModel]="column.filterValue"
                      (ngModelChange)="onTmColumnFilterValueChange(column, $event)"
                      placeholder="Leave blank for no default filter"
                    />
                  </div>
                </div>
              </div>
            </div>

            <button type="button" mat-stroked-button class="add-step-button tm-add-column" (click)="addTmColumn()"><mat-icon>add</mat-icon> Add column</button>
          </div>

          <div class="control-row" *ngIf="isTmNormal">
            <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onTmGroupByFieldDrop($event)" title="Drag a column here to group rows">
              <label>{{ fieldLabel('tableMatrix', 'groupBy', 'Group rows by') }}</label>
              <ng-select
                #ssTmGroup
                class="ss-select"
                [class.is-open]="!!ssTmGroup.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="drillDatasetColumns"
                [clearable]="true"
                [searchable]="true"
                [loading]="isDrillDatasetColumnsLoading"
                [disabled]="!drillDataset"
                placeholder="No grouping"
                [ngModel]="tmGroupBy || null"
                (ngModelChange)="tmGroupBy = $event || ''; onTableMatrixTypeChange()"
              ></ng-select>
            </div>
            <div class="control-group">
              <label>{{ fieldLabel('tableMatrix', 'aggregation', 'Aggregation') }}</label>
              <ng-select
                #ssTmAgg
                class="ss-select"
                [class.is-open]="!!ssTmAgg.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="tmAggregations"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [ngModel]="tmAggregation"
                (ngModelChange)="tmAggregation = $event; onTableMatrixTypeChange()"
              ></ng-select>
            </div>
          </div>

          <!-- ══ Matrix: row dimension × column dimension × measure ══ -->
          <ng-container *ngIf="isTmMatrix">
            <div class="control-row">
              <div class="control-group">
                <label>Row dimension</label>
                <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Rows down" [ngModel]="tmRowField || null" (ngModelChange)="tmRowField = $event || ''; onTableMatrixTypeChange()"></ng-select>
              </div>
              <div class="control-group">
                <label>Column dimension</label>
                <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Columns across" [ngModel]="tmColumnField || null" (ngModelChange)="tmColumnField = $event || ''; onTableMatrixTypeChange()"></ng-select>
              </div>
            </div>
            <div class="control-group">
              <label>Value (measure)</label>
              <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Numeric column to aggregate" [ngModel]="tmValueField || null" (ngModelChange)="tmValueField = $event || ''; onTableMatrixTypeChange()"></ng-select>
            </div>
          </ng-container>

          <!-- ══ Pivot: row fields × column fields × measure ══ -->
          <ng-container *ngIf="isTmPivot">
            <div class="control-group">
              <label>Row fields</label>
              <ng-select class="ss-select ss-select--multi" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [multiple]="true" [closeOnSelect]="false" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Rows (one or more)" [ngModel]="tmRowFields" (ngModelChange)="tmRowFields = $event || []; onTableMatrixTypeChange()"></ng-select>
            </div>
            <div class="control-group">
              <label>Column fields</label>
              <ng-select class="ss-select ss-select--multi" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [multiple]="true" [closeOnSelect]="false" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Columns (one or more)" [ngModel]="tmColumnFields2" (ngModelChange)="tmColumnFields2 = $event || []; onTableMatrixTypeChange()"></ng-select>
            </div>
            <div class="control-group">
              <label>Value (measure)</label>
              <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Numeric column to aggregate" [ngModel]="tmValueField || null" (ngModelChange)="tmValueField = $event || ''; onTableMatrixTypeChange()"></ng-select>
            </div>
          </ng-container>

          <!-- ══ Grouped: ordered group levels ══ -->
          <div class="control-group" *ngIf="isTmGrouped">
            <label>Group by (levels, outer → inner)</label>
            <ng-select class="ss-select ss-select--multi" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [multiple]="true" [closeOnSelect]="false" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Pick group columns in order" [ngModel]="tmGroupByFields" (ngModelChange)="tmGroupByFields = $event || []; onTableMatrixTypeChange()"></ng-select>
          </div>

          <!-- ══ Tree Grid: id + parent-id columns ══ -->
          <div class="control-row" *ngIf="isTmTreegrid">
            <div class="control-group">
              <label>Row ID column</label>
              <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Unique id" [ngModel]="tmTreeIdField || null" (ngModelChange)="tmTreeIdField = $event || ''; onTableMatrixTypeChange()"></ng-select>
            </div>
            <div class="control-group">
              <label>Parent ID column</label>
              <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Points to parent id" [ngModel]="tmTreeParentField || null" (ngModelChange)="tmTreeParentField = $event || ''; onTableMatrixTypeChange()"></ng-select>
            </div>
          </div>

          <!-- ══ Financial: role + indent columns ══ -->
          <div class="control-row" *ngIf="isTmFinancial">
            <div class="control-group">
              <label>Row role column (header/item/subtotal/total)</label>
              <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Optional role column" [ngModel]="tmRoleField || null" (ngModelChange)="tmRoleField = $event || ''; onTableMatrixTypeChange()"></ng-select>
            </div>
            <div class="control-group">
              <label>Indent column (optional)</label>
              <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="drillDatasetColumns" [clearable]="true" [searchable]="true" [disabled]="!drillDataset" placeholder="Numeric indent depth" [ngModel]="tmIndentField || null" (ngModelChange)="tmIndentField = $event || ''; onTableMatrixTypeChange()"></ng-select>
            </div>
          </div>

          <!-- ══ Navigation: click a cell value → open a target dashboard filtered ══ -->
          <div class="tm-nav-config">
            <div class="tm-nav-head" (click)="toggleTmNavAccordion()">
              <mat-icon>{{ tmNavAccordionOpen ? 'expand_more' : 'chevron_right' }}</mat-icon>
              <span>Navigation</span>
              <span class="tm-nav-badge" *ngIf="tmNavEnabled">on</span>
            </div>
            <div class="tm-nav-body" *ngIf="tmNavAccordionOpen">
              <label class="dvm-format-toggle tm-nav-enable">
                <input type="checkbox" [ngModel]="tmNavEnabled" (ngModelChange)="tmNavEnabled = $event; onTableMatrixTypeChange()" />
                Enable dashboard navigation
              </label>

              <ng-container *ngIf="tmNavEnabled">
                <div class="control-group">
                  <label>Filter column (value sent on navigate)</label>
                  <ng-select
                    #ssTmNavKey
                    class="ss-select"
                    [class.is-open]="!!ssTmNavKey.isOpen?.()"
                    appendTo="body"
                    ngClass="ss-dropdown-panel"
                    [items]="drillDatasetColumns"
                    [clearable]="true"
                    [searchable]="true"
                    [disabled]="!drillDataset"
                    placeholder="Defaults to the first column"
                    [ngModel]="tmNavFilterKey || null"
                    (ngModelChange)="tmNavFilterKey = $event || ''; onTableMatrixTypeChange()"
                  ></ng-select>
                </div>

                <div class="control-group">
                  <label>Clickable columns (empty = filter column only)</label>
                  <ng-select
                    #ssTmNavCols
                    class="ss-select ss-select--multi"
                    [class.is-open]="!!ssTmNavCols.isOpen?.()"
                    appendTo="body"
                    ngClass="ss-dropdown-panel"
                    [items]="drillDatasetColumns"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [hideSelected]="false"
                    [clearable]="true"
                    [searchable]="true"
                    [disabled]="!drillDataset"
                    placeholder="Filter column only"
                    [ngModel]="tmNavColumns"
                    (ngModelChange)="tmNavColumns = $event || []; onTableMatrixTypeChange()"
                  ></ng-select>
                </div>

                <div class="control-group">
                  <label>Target dashboard</label>
                  <ng-select
                    #ssTmNavDash
                    class="ss-select"
                    [class.is-open]="!!ssTmNavDash.isOpen?.()"
                    appendTo="body"
                    ngClass="ss-dropdown-panel"
                    [items]="tmNavTargetDashboards"
                    bindLabel="label"
                    bindValue="value"
                    [clearable]="true"
                    [searchable]="true"
                    placeholder="Pick a saved dashboard"
                    [ngModel]="tmNavTargetDashboard || null"
                    (ngModelChange)="tmNavTargetDashboard = $event || ''; onTmNavTargetDashboardChange()"
                  ></ng-select>
                  <small class="control-hint" *ngIf="!tmNavTargetDashboards.length">No saved dashboards yet — publish/save one to use as a target.</small>
                </div>

                <div class="control-group" *ngIf="tmNavTargetDashboard">
                  <label>Target components (empty = all charts)</label>
                  <ng-select
                    #ssTmNavComps
                    class="ss-select ss-select--multi"
                    [class.is-open]="!!ssTmNavComps.isOpen?.()"
                    appendTo="body"
                    ngClass="ss-dropdown-panel"
                    [items]="tmNavTargetComponentOptions"
                    bindLabel="label"
                    bindValue="value"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [hideSelected]="false"
                    [clearable]="true"
                    [searchable]="true"
                    placeholder="All charts on the target dashboard"
                    [ngModel]="tmNavTargetComponents"
                    (ngModelChange)="tmNavTargetComponents = $event || []; onTableMatrixTypeChange()"
                  ></ng-select>
                </div>

                <div class="control-group">
                  <label>Navigate button label</label>
                  <input type="text" [ngModel]="tmNavButtonLabel" (ngModelChange)="tmNavButtonLabel = $event; onTableMatrixTypeChange()" placeholder="Navigate" />
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- Table format options — the SAME config-driven format accordions as
             the Bar/Waterfall layouts (Formatting / Totals / Columns /
             Interaction / Export / Upload), fed by the TABLE_MATRIX-scoped
             formatControls in charts/table-matrix.json, gated per table type by
             `visibleWhenType` and by the capabilityRegistry `sections` list;
             the values fold into the tile on Generate and live-refresh the
             edited tile. For the DRILL-DOWN type these accordions render AFTER
             the Hierarchy dimensions / Measures / Chart-interactions block (see
             the second outlet lower down) so the required mapping comes first. -->
        <ng-container *ngIf="!isTmDrilldown" [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
      </div>

      <div class="drill-down-dimensions wf-field-drop-zone" *ngIf="isDrillDownLayout || (isTableMatrixLayout && isTmDrilldown)" (dragover)="allowFieldDrop($event)" (drop)="onDrillDimensionFieldDrop($event)">
        <header class="wf-section-header wf-steps-head">
          <h3>{{ layoutSectionTitle('dimensions', 'Hierarchy dimensions') }}</h3>
          <button type="button" mat-stroked-button (click)="addDrillDimension()">+ Add Level</button>
        </header>
        <small class="control-hint" *ngIf="layoutSectionHint('dimensions')">{{ layoutSectionHint('dimensions') }}</small>
        <small class="control-hint">One dataset drives every level.</small>
        <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

        <div class="wf-empty" *ngIf="!drillDownDimensions.length">
          No dimensions yet - add Level 1 and map fields like Type Grouping, Global Business Unit, Business Unit.
        </div>

        <div class="wf-step-card wf-field-drop-zone" *ngFor="let dimension of drillDownDimensions; let i = index; let first = first; let last = last" (dragover)="allowFieldDrop($event)" (drop)="onDrillDimensionFieldDrop($event, dimension)">
          <div class="wf-step-head">
            <span class="wf-step-index">{{ i + 1 }}</span>

            <ng-select
              #ssWfDimField
              class="ss-select wf-step-field-select"
              [class.is-open]="!!ssWfDimField.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="drillDatasetColumns"
              [clearable]="false"
              [searchable]="true"
              [loading]="isDrillDatasetColumnsLoading"
              [disabled]="!drillDataset"
              [placeholder]="drillColumnPlaceholder('dimension')"
              [ngModel]="dimension.field || null"
              (ngModelChange)="dimension.field = $event || ''; onDrillDimensionChange()"
            ></ng-select>

            <input
              type="text"
              class="wf-step-label"
              [ngModel]="dimension.label"
              (ngModelChange)="dimension.label = $event; onDrillDimensionChange()"
              placeholder="Display name"
              [matTooltip]="i === 0 ? 'Shown as the tree column header' : 'Sent to the backend for this level'"
            />

            <div class="wf-step-actions">
              <button type="button" mat-icon-button [disabled]="first" (click)="moveDrillDimensionUp(i)" matTooltip="Move up" aria-label="Move level up">
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <button type="button" mat-icon-button [disabled]="last" (click)="moveDrillDimensionDown(i)" matTooltip="Move down" aria-label="Move level down">
                <mat-icon>arrow_downward</mat-icon>
              </button>
              <button type="button" mat-icon-button class="row-remove-button" (click)="removeDrillDimension(dimension)" matTooltip="Remove level" aria-label="Remove level">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <!-- Optional fixed ordering for THIS level's values. Left blank, the
               key is omitted from the payload entirely and the backend keeps its
               default ordering. -->
          <div class="control-row" *ngIf="fieldEnabled('dimensions', 'valueOrder')">
            <div class="control-group control-group-full">
              <label>{{ fieldLabel('dimensions', 'valueOrder', 'Value order (optional)') }}</label>
              <input
                type="text"
                [ngModel]="dimension.valueOrder"
                (ngModelChange)="dimension.valueOrder = $event; onDrillDimensionChange()"
                placeholder="e.g. Base Options, Additional Options, Routing Cost"
              />
              <small class="control-hint">
                Comma-separated, in the order you want the rows to appear. Leave blank to keep the default order.
              </small>
            </div>
          </div>
        </div>
      </div>
    <div class="drill-down-measures wf-field-drop-zone" *ngIf="isDrillDownLayout || (isTableMatrixLayout && isTmDrilldown)" (dragover)="allowFieldDrop($event)" (drop)="onDrillMeasureFieldDrop($event)">
      <header class="wf-section-header wf-steps-head">
        <h3>{{ layoutSectionTitle('measures', 'Measures') }}</h3>
        <button type="button" mat-stroked-button (click)="addDrillMeasure()">+ Add Measure</button>
      </header>
      <small class="control-hint" *ngIf="layoutSectionHint('measures')">{{ layoutSectionHint('measures') }}</small>

      <div class="wf-empty" *ngIf="!drillDownMeasures.length">
        No measures yet — add at least one value column (e.g. DN Price) to show and roll up at every level.
      </div>

      <div class="wf-step-card wf-field-drop-zone" *ngFor="let measure of drillDownMeasures; let i = index; let first = first; let last = last" (dragover)="allowFieldDrop($event)" (drop)="onDrillMeasureFieldDrop($event, measure)">
        <div class="wf-step-head">
          <span class="wf-step-index">{{ i + 1 }}</span>

          <ng-select
            #ssWfMeasureField
            class="ss-select wf-step-field-select"
            [class.is-open]="!!ssWfMeasureField.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="drillDatasetColumns"
            [clearable]="false"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="drillColumnPlaceholder('measure')"
            [ngModel]="measure.field || null"
            (ngModelChange)="measure.field = $event || ''; onDrillMeasureChange()"
          ></ng-select>

          <input
            type="text"
            class="wf-step-label"
            [ngModel]="measure.label"
            (ngModelChange)="measure.label = $event; onDrillMeasureChange()"
            placeholder="Measure label"
          />
<div class="wf-step-actions">
            <button type="button" mat-icon-button [disabled]="first" (click)="moveDrillMeasureUp(i)" matTooltip="Move up" aria-label="Move measure up">
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button type="button" mat-icon-button [disabled]="last" (click)="moveDrillMeasureDown(i)" matTooltip="Move down" aria-label="Move measure down">
              <mat-icon>arrow_downward</mat-icon>
            </button>
            <button type="button" mat-icon-button class="row-remove-button" (click)="removeDrillMeasure(measure)" matTooltip="Remove measure" aria-label="Remove measure">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div class="wf-step-body">
          <div class="control-group" *ngIf="fieldEnabled('measures', 'aggregation')">
            <label>{{ fieldLabel('measures', 'aggregation', 'Aggregation') }}</label>
            <ng-select
              #ssWfMeasureAgg
              class="ss-select"
              [class.is-open]="!!ssWfMeasureAgg.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="measureAggregations"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [ngModel]="measure.aggregation"
              (ngModelChange)="measure.aggregation = $event; onDrillMeasureChange()"
            ></ng-select>
          </div>
          <div class="control-group" *ngIf="fieldEnabled('measures', 'rollUpStrategy')">
            <label>{{ fieldLabel('measures', 'rollUpStrategy', 'Roll-up strategy') }}</label>
            <ng-select
              #ssWfMeasureRollup
              class="ss-select"
              [class.is-open]="!!ssWfMeasureRollup.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="rollUpStrategies"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [ngModel]="measure.rollUpStrategy"
              (ngModelChange)="measure.rollUpStrategy = $event; onDrillMeasureChange()"
            ></ng-select>
          </div>
          <div class="control-group" *ngIf="fieldEnabled('measures', 'total')">
            <label class="checkbox-label" matTooltip="Adds this measure to a dataset-wide Grand Total row at the bottom of the table">
              <input
                type="checkbox"
                [ngModel]="measure.total"
                (ngModelChange)="measure.total = $event; onDrillMeasureChange()"
              />
              {{ fieldLabel('measures', 'total', 'Show in Grand Total') }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Drill-Down Table: Format accordions (registry `sections`-gated). The
         Table & Matrix drill-down variant gets its own accordion in its block. -->
    <ng-container *ngIf="isDrillDownLayout" [ngTemplateOutlet]="chartFormatAccordion"></ng-container>

    <!-- Shared reference-list template: one card per typed reference, scoped to
         a specific WATERFALL bar (`step` set) or a single formula (`step`
         null) — used by the Input-control target formulas below AND by a
         chart's OWN formula field (KPI / horizontal bar), keyed by that
         chart's own componentId rather than a target id. Declared here, above
         every section that uses it, so it's in scope for all of them. -->
    <!-- Dataset picker + status — one definition, used by every chart section. -->
    <ng-template #datasetPicker>
      <div class="control-group" *ngIf="fieldEnabled('config', 'dataset')">
        <label>{{ fieldLabel('config', 'dataset', 'Dataset') }}</label>
        <ng-select
          #ssSharedDataset
          class="ss-select"
          [class.is-open]="!!ssSharedDataset.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="entityOptions"
          [loading]="entitiesLoading"
          [clearable]="false"
          [searchable]="true"
          placeholder="Pick the data table to render"
          [ngModel]="drillDataset || null"
          (ngModelChange)="onSelectedDatasetsChange($event ? [$event] : [])"
        ></ng-select>
        <small class="control-hint" *ngIf="datasetStatus.kind === 'hint'">{{ datasetStatus.text }}</small>
        <small class="control-warning" *ngIf="datasetStatus.kind === 'error'">
          {{ datasetStatus.text }}
          <button type="button" class="target-reference-add" *ngIf="datasetStatus.canRetry" (click)="reloadDatasets()">Retry</button>
        </small>
      </div>
    </ng-template>

    <ng-template #referenceList let-id="id" let-step="step">
      <div class="target-reference-list">
        <div class="target-reference-card" *ngFor="let ref of targetReferences(id, step)">
          <div class="target-reference-card-header">
            <span>Reference</span>
            <button type="button" class="target-reference-remove" (click)="removeTargetReference(id, ref)" title="Remove reference">&times;</button>
          </div>
          <div class="target-reference-grid">
            <div class="control-group">
              <label>Token</label>
              <input type="text" [(ngModel)]="ref.token" placeholder="e.g. DN Price" />
            </div>
            <div class="control-group">
              <label>Input title</label>
              <input type="text" [(ngModel)]="ref.inputTitle" placeholder="e.g. Price Inflation %" />
            </div>
            <div class="control-group">
              <label>Target label</label>
              <input type="text" [(ngModel)]="ref.targetLabel" placeholder="e.g. Product Margins" />
            </div>
            <div class="control-group">
              <label>Row label</label>
              <input type="text" [(ngModel)]="ref.rowLabel" placeholder="e.g. DN Price" />
            </div>
          </div>
          <small class="control-warning" *ngIf="isDuplicateReferenceToken(id, ref, step)">
            Another reference already uses token "{{ ref.token.trim() }}" — only one is sent. Give each a unique token.
          </small>
        </div>
        <button type="button" class="target-reference-add" (click)="addTargetReference(id, step)">+ Add reference</button>
      </div>
    </ng-template>

    <!-- Horizontal Bar Chart: one group-by field (Y-axis) + one formula-driven
         value (X-axis). Single dataset (first of "Datasets" above). -->
    <div class="wf-section" *ngIf="isHorizontalBarLayout">
      <header class="wf-section-header">
        <h3>{{ layoutSectionTitle('axes', 'Bar axes') }}</h3>
      </header>
      <small class="control-hint" *ngIf="layoutSectionHint('axes')">{{ layoutSectionHint('axes') }}</small>
      <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

      <div class="control-row">
        <div class="control-group wf-field-drop-zone" *ngIf="fieldEnabled('axes', 'groupByField')" (dragover)="allowFieldDrop($event)" (drop)="onHorizontalBarGroupFieldDrop($event)">
          <label>{{ fieldLabel('axes', 'groupByField', 'Y-axis — group by') }}</label>
          <ng-select
            #ssHbGroup
            class="ss-select"
            [class.is-open]="!!ssHbGroup.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="drillDatasetColumns"
            [clearable]="false"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="drillColumnPlaceholder('dimension')"
            [ngModel]="hbGroupByField || null"
            (ngModelChange)="hbGroupByField = $event || ''"
          ></ng-select>
        </div>
        <div class="control-group" *ngIf="fieldEnabled('axes', 'groupByLabel')">
          <label>{{ fieldLabel('axes', 'groupByLabel', 'Y-axis display name') }}</label>
          <input type="text" [(ngModel)]="hbGroupByLabel" placeholder="e.g. Type Grouping" />
        </div>
      </div>

      <div class="control-row">
        <div class="control-group" *ngIf="fieldEnabled('axes', 'valueLabel')">
          <label>{{ fieldLabel('axes', 'valueLabel', 'X-axis value label') }}</label>
          <input type="text" [(ngModel)]="hbValueLabel" placeholder="Value" />
        </div>
        <div class="control-group control-group-full wf-field-drop-zone" *ngIf="fieldEnabled('axes', 'valueFormula')" (dragover)="allowFieldDrop($event)" (drop)="onHorizontalBarValueFieldDrop($event)">
          <label>{{ fieldLabel('axes', 'valueFormula', 'X-axis value formula') }}</label>
          <input type="text" [(ngModel)]="hbValueFormula" placeholder="e.g. [price] + [sum_of_cost_2026]" />
          <small class="control-hint">Used for any group with no override below. Leave blank if every group has one.</small>
        </div>
      </div>

      <!-- Per-group formula overrides: some groups genuinely compute their value
           differently (e.g. a "Base Options" row folding in one adjustment while
           "Additional Options" folds in a different one) rather than one formula
           applying uniformly to every group. A group not listed here falls back
           to the shared formula above. -->
      <div class="control-row">
        <div class="control-group control-group-full">
          <label>Per-group formula overrides (optional)</label>
          <small class="control-hint">
            One formula per group value (matched against the Y-axis field above). A group listed here ignores the shared formula.
          </small>
          <div class="target-reference-row" *ngFor="let entry of hbGroupFormulas">
            <input type="text" [(ngModel)]="entry.group" placeholder="Group value, e.g. Base Options" />
            <input type="text" [(ngModel)]="entry.formula" placeholder="Formula for this group" />
            <button type="button" class="target-reference-remove" (click)="removeHbGroupFormula(entry)">Remove</button>
          </div>
          <button type="button" class="target-reference-add" (click)="addHbGroupFormula()">+ Add group formula</button>
        </div>
      </div>

      <!-- References: when this formula's [Token] isn't a plain dataset column
           but another input's live/recomputed output, type in where it comes
           from so the backend resolves the CURRENT value instead of a stale
           one. Keyed by THIS chart's own componentId. -->
      <ng-container *ngIf="formulaReferencesEnabledFor('HORIZONTAL_BAR_CHART')">
        <ng-container *ngTemplateOutlet="referenceList; context: { id: componentId }"></ng-container>
      </ng-container>

      <!-- Format accordions (registry `sections`-gated; shell formatControls) -->
      <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
    </div>
    <!-- KPI card: single dataset, one column aggregated (sum / distinct / …) to
         a single headline value. -->
    <div class="wf-section" *ngIf="isKpiLayout">
      <header class="wf-section-header">
        <h3>{{ layoutSectionTitle('kpi', 'KPI card') }}</h3>
      </header>
      <small class="control-hint" *ngIf="layoutSectionHint('kpi')">{{ layoutSectionHint('kpi') }}</small>
      <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

      <div class="control-row">
        <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onKpiFieldDrop($event)" title="Drag a column here">
          <label>{{ fieldLabel('kpi', 'field', 'Column') }}</label>
          <ng-select
            #ssKpiField
            class="ss-select"
            [class.is-open]="!!ssKpiField.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="drillDatasetColumns"
            [clearable]="false"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="drillColumnPlaceholder('measure')"
            [ngModel]="kpiField || null"
            (ngModelChange)="kpiField = $event || ''"
          ></ng-select>
        </div>
        <div class="control-group">
          <label>{{ fieldLabel('kpi', 'aggregation', 'Aggregation') }}</label>
          <ng-select
            #ssKpiAgg
            class="ss-select"
            [class.is-open]="!!ssKpiAgg.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="kpiAggregations"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngModel]="kpiAggregation"
            (ngModelChange)="kpiAggregation = $event"
          ></ng-select>
        </div>
      </div>
      <div class="control-row" *ngIf="fieldEnabled('kpi', 'formula')">
        <div class="control-group control-group-full wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onKpiFormulaFieldDrop($event)" title="Drag a column here">
          <label>{{ fieldLabel('kpi', 'formula', 'Formula (optional)') }}</label>
          <input type="text" [(ngModel)]="kpiFormula" placeholder="e.g. [price] * [qty] — overrides Column + Aggregation when set" />
        </div>
      </div>

      <!-- References: when the formula's [Token] isn't a plain dataset column
           but another input's live/recomputed output, type in where it comes
           from so the backend resolves the CURRENT value instead of a stale
           one. Keyed by THIS KPI's own componentId. -->
      <ng-container *ngIf="fieldEnabled('kpi', 'formula') && formulaReferencesEnabledFor('KPI')">
        <ng-container *ngTemplateOutlet="referenceList; context: { id: componentId }"></ng-container>
      </ng-container>

      <!-- Format accordions (registry `sections`-gated; shell formatControls) -->
      <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
    </div>

    <!-- Bar & Column (BAR): ONE builder → the whole family. Orientation toggle
         (Horizontal/Vertical) + variant picker (Simple/Grouped/Stacked/100%/
         Clustered) decide how the mapped category + measures render. -->
    <div class="wf-section wf-section-plain" *ngIf="isBarLayout">
      <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

      <!-- Family card — mirrors the "Chart configuration" card style (icon + divider
           heading, padded white card) so the two sections read consistently. -->
      <div class="bridge-chart-settings bar-family-card">
        <div class="bridge-settings-heading"><mat-icon>bar_chart</mat-icon><span>{{ layoutSectionTitle('bar', 'Bar & column') }}</span></div>
        <small class="control-hint" *ngIf="layoutSectionHint('bar')">{{ layoutSectionHint('bar') }}</small>

        <!-- Orientation toggle -->
        <div class="control-group bar-orientation-field" *ngIf="fieldEnabled('bar', 'orientation')">
          <label>{{ fieldLabel('bar', 'orientation', 'Orientation') }}</label>
          <div class="wf-step-mode-toggle" role="group" aria-label="Bar orientation">
            <button type="button" [class.is-active]="barOrientation === 'vertical'" (click)="barOrientation = 'vertical'; onBarChange()">
              <mat-icon>bar_chart</mat-icon> Vertical
            </button>
            <button type="button" [class.is-active]="barOrientation === 'horizontal'" (click)="barOrientation = 'horizontal'; onBarChange()">
              <mat-icon>align_horizontal_left</mat-icon> Horizontal
            </button>
          </div>
        </div>

        <!-- Variant — its selection decides what the builder needs (Simple = no
             split; Grouped/Clustered/Stacked/100% = a required Split column). -->
        <div class="control-group" *ngIf="fieldEnabled('bar', 'variant')">
          <label>{{ fieldLabel('bar', 'variant', 'Variant') }}</label>
          <ng-select
            #ssBarVariant
            class="ss-select"
            [class.is-open]="!!ssBarVariant.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="barVariants"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngModel]="barVariant"
            (ngModelChange)="barVariant = $event; onBarChange()"
          ></ng-select>
          <small class="control-hint wf-variant-hint" *ngIf="barVariantHint">{{ barVariantHint }}</small>
        </div>
      </div>

      <!-- ══ Chart Data accordion — axis / measure / series mapping ══ -->
      <div class="bar-options-accordion">
        <div class="dvm-format-group" [class.is-open]="barDataAccordionOpen">
          <button type="button" class="dvm-format-group-head" (click)="barDataAccordionOpen = !barDataAccordionOpen">
            <span>Chart Data</span>
            <mat-icon>{{ barDataAccordionOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="dvm-format-group-body" *ngIf="barDataAccordionOpen">

      <div class="control-row">
        <!-- Category = the group axis (X when vertical, Y when horizontal). -->
        <div class="control-group wf-field-drop-zone" *ngIf="fieldEnabled('bar', 'category')" (dragover)="allowFieldDrop($event)" (drop)="onBarCategoryFieldDrop($event)" title="Drag a column here">
          <label>{{ barCategoryAxisLabel }} <span class="wf-axis-hint">— group by</span></label>
          <ng-select
            #ssBarCategory
            class="ss-select"
            [class.is-open]="!!ssBarCategory.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="barColumns"
            [clearable]="false"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="barColumnPlaceholder()"
            [ngModel]="barCategory || null"
            (ngModelChange)="barCategory = $event || ''; onBarChange()"
          ></ng-select>
        </div>
        <!-- Hierarchical Category Axis — optional OUTER group (parent → child). -->
        <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onBarParentFieldDrop($event)" title="Drag a column here">
          <label>Group by (parent) <span class="wf-axis-hint">(optional — hierarchical)</span></label>
          <ng-select
            #ssBarParent
            class="ss-select"
            [class.is-open]="!!ssBarParent.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="barColumns"
            [clearable]="true"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="barColumnPlaceholder()"
            [ngModel]="barCategoryParent || null"
            (ngModelChange)="barCategoryParent = $event || ''; onBarChange()"
          ></ng-select>
        </div>
      </div>

      <div class="control-row">
        <!-- Series = split each group into sub-bars → legend. REQUIRED for the
             split-based variants (grouped/clustered/stacked/100%); hidden for Simple. -->
        <div class="control-group wf-field-drop-zone" [class.is-required-empty]="barSeriesRequired && !barSeries" *ngIf="fieldEnabled('bar', 'series') && barVariantUsesSeries" (dragover)="allowFieldDrop($event)" (drop)="onBarSeriesFieldDrop($event)" title="Drag a column here">
          <label>Split / Legend <span class="wf-axis-hint">{{ barSeriesRequired ? '(required)' : '(optional)' }}</span></label>
          <ng-select
            #ssBarSeries
            class="ss-select"
            [class.is-open]="!!ssBarSeries.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="barColumns"
            [clearable]="!barSeriesRequired"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="barSeriesRequired ? 'Pick a column to split by' : barColumnPlaceholder()"
            [ngModel]="barSeries || null"
            (ngModelChange)="barSeries = $event || ''; onBarChange()"
          ></ng-select>
          <!-- <small class="control-warning" *ngIf="barSeriesRequired && !barSeries">This variant needs a Split column to render as {{ barVariant }}.</small> -->
          <small class="control-hint" *ngIf="barSeriesComesFromMeasures">Leave empty to use one series per measure below — that way a series can be a formula (add it under Measures).</small>
        </div>
      </div>

      <!-- Secondary axes — a bar chart's second VALUE axis (dual). BOTH pickers
           (Secondary X + Secondary Y) are ALWAYS shown for every variant and
           orientation; the active one folds into capabilities via
           barActiveSecondaryField (Sec. Y when Vertical, Sec. X when Horizontal). -->
      <div class="control-row">
        <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onBarSecondaryAxisFieldDrop($event, 'x')" title="Drag a column here">
          <label>Secondary X-axis <span class="wf-axis-hint">(values)</span></label>
          <ng-select
            #ssBarSecX
            class="ss-select"
            [class.is-open]="!!ssBarSecX.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="barColumns"
            [clearable]="true"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="barColumnPlaceholder()"
            [ngModel]="barSecondaryXField || null"
            (ngModelChange)="barSecondaryXField = $event || ''; onBarChange()"
          ></ng-select>
        </div>
        <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onBarSecondaryAxisFieldDrop($event, 'y')" title="Drag a column here">
          <label>Secondary Y-axis <span class="wf-axis-hint">(values)</span></label>
          <ng-select
            #ssBarSecY
            class="ss-select"
            [class.is-open]="!!ssBarSecY.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="barColumns"
            [clearable]="true"
            [searchable]="true"
            [loading]="isDrillDatasetColumnsLoading"
            [disabled]="!drillDataset"
            [placeholder]="barColumnPlaceholder()"
            [ngModel]="barSecondaryYField || null"
            (ngModelChange)="barSecondaryYField = $event || ''; onBarChange()"
          ></ng-select>
        </div>
      </div>

      <!-- Measures = the value axis (Y when vertical, X when horizontal). Each row
           is one measure: column + draw-as + primary/secondary axis (+ reorder). -->
      <div class="wf-subsection-header">
        <span>{{ barValueAxisLabel }} <span class="wf-axis-hint">— values</span> <span class="wf-step-count">{{ barMeasures.length }}</span></span>
        <!-- Add measure only where extra measures actually render (Simple Bar,
             Comparison). Series-split variants use ONE measure, so it's hidden. -->
        <button type="button" class="add-step-button" mat-stroked-button *ngIf="barAllowsMultipleMeasures" (click)="addBarMeasure()"><mat-icon>add</mat-icon> Add measure</button>
      </div>
      <small class="control-hint" *ngIf="barVariantUsesSeries && barSeries">Series split active — the first measure supplies the value.</small>
      <small class="control-hint" *ngIf="barSeriesComesFromMeasures">No Split column picked — each measure below renders as its own series. Use the Formula Builder to add a computed column, then select it here.</small>

      <div class="wf-field-drop-zone bar-measures-zone" (dragover)="allowFieldDrop($event)" (drop)="onBarMeasureFieldDrop($event)">
        <div class="wf-empty" *ngIf="!barMeasures.length">No measures yet — add one, or drag a column here.</div>

        <div class="bar-measure-row" *ngFor="let measure of barMeasures; let i = index; let first = first; let last = last">
          <div class="control-row">
            <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onBarMeasureFieldDrop($event, measure)" title="Drag a column here">
              <label>Column</label>
              <ng-select
                class="ss-select"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="barColumns"
                [clearable]="false"
                [searchable]="true"
                [loading]="isDrillDatasetColumnsLoading"
                [disabled]="!drillDataset"
                [placeholder]="barColumnPlaceholder()"
                [ngModel]="measure.field || null"
                (ngModelChange)="measure.field = $event || ''; onBarMeasureChange()"
              ></ng-select>
            </div>
            <div class="control-group">
              <label>Label</label>
              <input type="text" [ngModel]="measure.label" (ngModelChange)="measure.label = $event; onBarMeasureChange()" [placeholder]="measure.field || 'Measure'" />
            </div>
          </div>
          <div class="control-row">
            <!-- Draw-as (Bar/Line/Area) — combos. Hidden for series-split variants. -->
            <div class="control-group" *ngIf="fieldEnabled('bar', 'renderAs') && !(barVariantUsesSeries && barSeries)">
              <label>{{ fieldLabel('bar', 'renderAs', 'Draw as') }}</label>
              <ng-select
                class="ss-select"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="barRenderTypes"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [ngModel]="measure.renderAs"
                (ngModelChange)="measure.renderAs = $event; onBarMeasureChange()"
              ></ng-select>
            </div>
            <!-- Axis (primary/secondary) — dual axis. Hidden for series-split variants. -->
            <div class="control-group" *ngIf="fieldEnabled('bar', 'axis') && !(barVariantUsesSeries && barSeries)">
              <label>{{ fieldLabel('bar', 'axis', 'Axis') }}</label>
              <ng-select
                class="ss-select"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="barAxisOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [ngModel]="measure.axis"
                (ngModelChange)="measure.axis = $event; onBarMeasureChange()"
              ></ng-select>
            </div>
            <!-- Reorder / remove only when multiple measures apply AND more than
                 one exists (a single required measure has nothing to reorder). -->
            <div class="control-group bar-measure-actions" *ngIf="barAllowsMultipleMeasures && barMeasures.length > 1">
              <button type="button" mat-icon-button (click)="moveBarMeasureUp(i)" [disabled]="first" matTooltip="Move up"><mat-icon>arrow_upward</mat-icon></button>
              <button type="button" mat-icon-button (click)="moveBarMeasureDown(i)" [disabled]="last" matTooltip="Move down"><mat-icon>arrow_downward</mat-icon></button>
              <button type="button" mat-icon-button class="row-remove-button" (click)="removeBarMeasure(measure)" matTooltip="Remove measure"><mat-icon>close</mat-icon></button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reference / target lines — drawn across the value axis. -->
      <div class="wf-subsection-header">
        <span>Reference lines <span class="wf-step-count">{{ barReferenceLines.length }}</span></span>
        <button type="button" class="add-step-button" mat-stroked-button (click)="addBarReferenceLine()"><mat-icon>add</mat-icon> Add line</button>
      </div>
      <div class="bar-refline-list" *ngIf="barReferenceLines.length">
        <div class="control-row bar-refline-row" *ngFor="let line of barReferenceLines">
          <div class="control-group">
            <label>Value</label>
            <input type="number" [ngModel]="line.value" (ngModelChange)="line.value = $event; onBarReferenceLineChange()" placeholder="e.g. 100" />
          </div>
          <div class="control-group">
            <label>Label</label>
            <input type="text" [ngModel]="line.label" (ngModelChange)="line.label = $event; onBarReferenceLineChange()" placeholder="Target" />
          </div>
          <div class="control-group bar-refline-color">
            <label>Color</label>
            <input type="color" [ngModel]="line.color" (ngModelChange)="line.color = $event; onBarReferenceLineChange()" />
          </div>
          <button type="button" mat-icon-button class="bar-refline-remove row-remove-button" (click)="removeBarReferenceLine(line.id)" matTooltip="Remove line"><mat-icon>close</mat-icon></button>
        </div>
      </div>

      <!-- Value formula — computed by the BACKEND, so unlike the Formula Builder
           below it can reference a live input value via [Token] + References. -->
      <div class="control-row" *ngIf="fieldEnabled('bar', 'valueFormula')">
        <div class="control-group control-group-full wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onBarValueFormulaFieldDrop($event)">
          <label>{{ fieldLabel('bar', 'valueFormula', 'Value formula (computed)') }}</label>
          <input type="text" [(ngModel)]="barValueFormula" placeholder="e.g. (AVG(base_price)*(1+[Price Inflation %]/100))" />
          <small class="control-hint">
            Computed by the backend, so it can use a live input value via [Token] (add it under References below).
            Leave blank to just aggregate the Measures above. Used for any group with no override below.
          </small>
        </div>
      </div>

      <div class="control-row" *ngIf="fieldEnabled('bar', 'valueFormula') && barUsesValueFormula">
        <div class="control-group">
          <label>Value label</label>
          <input type="text" [(ngModel)]="barValueLabel" placeholder="Value" />
        </div>
      </div>

      <div class="control-row" *ngIf="fieldEnabled('bar', 'valueFormula')">
        <div class="control-group control-group-full">
          <label>Per-group formula overrides (optional)</label>
          <small class="control-hint">
            One formula per category value (matched against the {{ barCategoryAxisLabel }} field above). A group listed here ignores the shared formula.
          </small>
          <div class="target-reference-row" *ngFor="let entry of barGroupFormulas">
            <input type="text" [(ngModel)]="entry.group" placeholder="Group value, e.g. Base Options" />
            <input type="text" [(ngModel)]="entry.formula" placeholder="Formula for this group" />
            <button type="button" class="target-reference-remove" (click)="removeBarGroupFormula(entry)">Remove</button>
          </div>
          <button type="button" class="target-reference-add" (click)="addBarGroupFormula()">+ Add group formula</button>
        </div>
      </div>

      <!-- Resolves each [Token] above to another tile's current value. -->
      <ng-container *ngIf="fieldEnabled('bar', 'valueFormula') && formulaReferencesEnabledFor('BAR')">
        <ng-container *ngTemplateOutlet="referenceList; context: { id: componentId }"></ng-container>
      </ng-container>

      <!-- Formula Builder — row-level COMPUTED columns from the dataset's columns.
           A computed column (e.g. "Margin = ([Profit] / [Revenue]) * 100") becomes
           a mappable column in Category / Measure / Split above. Fully config-driven
           (options.formulaBuilder): text, templates, validation, and the enabled
           flag all come from JSON. -->
      <div class="dvm-formula-builder" *ngIf="formulaBuilderEnabled">
        <button type="button" class="dvm-formula-head" (click)="barFormulaAccordionOpen = !barFormulaAccordionOpen">
          <span><mat-icon class="dvm-formula-head-icon">functions</mat-icon> {{ formulaBuilderConfig.title || 'Formula Builder' }} <span class="wf-step-count">{{ barComputedColumns.length }}</span></span>
          <mat-icon>{{ barFormulaAccordionOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        <div class="dvm-formula-body" *ngIf="barFormulaAccordionOpen">
          <p class="dvm-formula-hint" *ngIf="formulaBuilderConfig.hint">{{ formulaBuilderConfig.hint }}</p>

          <!-- Quick templates — click to fill the form below. -->
          <div class="dvm-formula-templates" *ngIf="barFormulaTemplates.length">
            <small class="control-hint">{{ formulaBuilderConfig.templatesLabel || 'Quick templates:' }}</small>
            <button
              type="button"
              class="dvm-formula-chip"
              *ngFor="let tpl of barFormulaTemplates"
              [title]="tpl.description"
              (click)="applyBarFormulaTemplate(tpl)"
            >{{ tpl.label }}</button>
          </div>

          <!-- Existing computed columns. -->
          <div class="dvm-formula-list" *ngIf="barComputedColumns.length">
            <div class="dvm-formula-item" *ngFor="let col of barComputedColumns">
              <div class="dvm-formula-item-info">
                <strong>{{ col.name }}</strong>
                <small>= {{ col.expression }}</small>
              </div>
              <button type="button" mat-icon-button class="bar-refline-remove row-remove-button" (click)="removeBarComputedColumn(col.name)" matTooltip="Remove column"><mat-icon>close</mat-icon></button>
            </div>
          </div>

          <!-- Add a new computed column. -->
          <div class="dvm-formula-add">
            <input type="text" [(ngModel)]="newBarColumnName" [placeholder]="formulaBuilderConfig.namePlaceholder || 'Column name'" />
            <input type="text" [(ngModel)]="newBarColumnExpression" [placeholder]="formulaBuilderConfig.expressionPlaceholder || 'Expression'" />
            <button type="button" class="add-step-button" mat-stroked-button (click)="addBarComputedColumn()"><mat-icon>add</mat-icon> {{ formulaBuilderConfig.addLabel || 'Add column' }}</button>
          </div>
          <small class="control-warning" *ngIf="newBarColumnError">{{ newBarColumnError }}</small>
        </div>
      </div>

          </div><!-- /Chart Data body -->
        </div><!-- /Chart Data group -->
      </div><!-- /Chart Data accordion -->

      <!-- Bar chart options — Title / Axis / Legend / Labels / Tooltip / Formatting /
           Interaction / Advanced accordions (shared template below). -->
      <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
    </div>

    <!-- ══════════════════ Line & Area builder ══════════════════
         Mirrors the Bar builder: a family card (variant picker), a Chart-Data
         accordion (X / Series / Secondary-Y pickers + N measures + reference
         lines), then the config-driven Format accordions. Renders client-side. -->
    <div class="wf-section wf-section-plain" *ngIf="isLineAreaLayout">
      <small class="control-warning" *ngIf="drillColumnsErrorMessage">{{ drillColumnsErrorMessage }} (see console for details)</small>

      <div class="bridge-chart-settings bar-family-card">
        <div class="bridge-settings-heading"><mat-icon>show_chart</mat-icon><span>{{ layoutSectionTitle('lineArea', 'Line & area') }}</span></div>
        <small class="control-hint" *ngIf="layoutSectionHint('lineArea')">{{ layoutSectionHint('lineArea') }}</small>

        <div class="control-group">
          <label>Variant</label>
          <ng-select
            #ssLaVariant
            class="ss-select"
            [class.is-open]="!!ssLaVariant.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="lineAreaVariants"
            bindLabel="label"
            bindValue="value"
            groupBy="group"
            [clearable]="false"
            [ngModel]="laVariant"
            (ngModelChange)="laVariant = $event; onLineAreaChange()"
          ></ng-select>
          <small class="control-hint wf-variant-hint" *ngIf="laVariantHint">{{ laVariantHint }}</small>
        </div>
      </div>

      <!-- ══ Chart Data accordion ══ -->
      <div class="bar-options-accordion">
        <div class="dvm-format-group is-open">
          <div class="dvm-format-group-head" style="cursor: default;">
            <span>Chart Data</span>
          </div>
          <div class="dvm-format-group-body">

            <div class="control-row">
              <!-- Category = the X axis. -->
              <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onLaCategoryFieldDrop($event)" title="Drag a column here">
                <label>X axis <span class="wf-axis-hint">— group by</span></label>
                <ng-select
                  #ssLaCategory class="ss-select" [class.is-open]="!!ssLaCategory.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="barColumns" [clearable]="false" [searchable]="true" [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  [placeholder]="barColumnPlaceholder()" [ngModel]="laCategory || null" (ngModelChange)="laCategory = $event || ''; onLineAreaChange()"
                ></ng-select>
              </div>
              <!-- Series split — REQUIRED for Multi-Line / Stacked Area / 100%. -->
              <div class="control-group wf-field-drop-zone" [class.is-required-empty]="laSeriesRequired && !laSeries" *ngIf="laVariantUsesSeries" (dragover)="allowFieldDrop($event)" (drop)="onLaSeriesFieldDrop($event)" title="Drag a column here">
                <label>Split / Legend <span class="wf-axis-hint">{{ laSeriesRequired ? '(required)' : '(optional)' }}</span></label>
                <ng-select
                  #ssLaSeries class="ss-select" [class.is-open]="!!ssLaSeries.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="barColumns" [clearable]="!laSeriesRequired" [searchable]="true" [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  [placeholder]="laSeriesRequired ? 'Pick a column to split by' : barColumnPlaceholder()" [ngModel]="laSeries || null" (ngModelChange)="laSeries = $event || ''; onLineAreaChange()"
                ></ng-select>
              </div>
            </div>

            <!-- Secondary axes — ALWAYS shown. Secondary X = a second category
                 column on a top X-axis (its own series); Secondary Y = dual value axis. -->
            <div class="control-row">
              <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onLaSecondaryXFieldDrop($event)" title="Drag a column here">
                <label>Secondary X-axis <span class="wf-axis-hint">(top — category)</span></label>
                <ng-select
                  #ssLaSecX class="ss-select" [class.is-open]="!!ssLaSecX.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="barColumns" [clearable]="true" [searchable]="true" [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  [placeholder]="barColumnPlaceholder()" [ngModel]="laSecondaryXField || null" (ngModelChange)="laSecondaryXField = $event || ''; onLineAreaChange()"
                ></ng-select>
              </div>
              <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onLaSecondaryYFieldDrop($event)" title="Drag a column here">
                <label>Secondary Y-axis <span class="wf-axis-hint">(values — dual)</span></label>
                <ng-select
                  #ssLaSecY class="ss-select" [class.is-open]="!!ssLaSecY.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="barColumns" [clearable]="true" [searchable]="true" [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  [placeholder]="barColumnPlaceholder()" [ngModel]="laSecondaryYField || null" (ngModelChange)="laSecondaryYField = $event || ''; onLineAreaChange()"
                ></ng-select>
              </div>
            </div>
            <!-- Value plotted against the secondary X axis (defaults to the first measure). -->
            <div class="control-row" *ngIf="laSecondaryXField">
              <div class="control-group">
                <label>Secondary X value <span class="wf-axis-hint">(defaults to first measure)</span></label>
                <ng-select
                  #ssLaSecXVal class="ss-select" [class.is-open]="!!ssLaSecXVal.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="barColumns" [clearable]="true" [searchable]="true" [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  [placeholder]="barColumnPlaceholder()" [ngModel]="laSecondaryXValueField || null" (ngModelChange)="laSecondaryXValueField = $event || ''; onLineAreaChange()"
                ></ng-select>
              </div>
            </div>

            <!-- Measures = the value axis. Each row: column + draw-as + axis (+ reorder). -->
            <div class="wf-subsection-header">
              <span>Y values <span class="wf-axis-hint">— measures</span> <span class="wf-step-count">{{ laMeasures.length }}</span></span>
              <button type="button" class="add-step-button" mat-stroked-button *ngIf="laAllowsMultipleMeasures" (click)="addLaMeasure()"><mat-icon>add</mat-icon> Add measure</button>
            </div>
            <small class="control-hint" *ngIf="laVariantUsesSeries && laSeries">Series split active — the first measure supplies the value.</small>

            <div class="wf-field-drop-zone bar-measures-zone" (dragover)="allowFieldDrop($event)" (drop)="onLaMeasureFieldDrop($event)">
              <div class="wf-empty" *ngIf="!laMeasures.length">No measures yet — add one, or drag a column here.</div>
              <div class="bar-measure-row" *ngFor="let measure of laMeasures; let i = index; let first = first; let last = last">
                <div class="control-row">
                  <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onLaMeasureFieldDrop($event, measure)" title="Drag a column here">
                    <label>Column</label>
                    <ng-select
                      class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="barColumns" [clearable]="false" [searchable]="true"
                      [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset" [placeholder]="barColumnPlaceholder()"
                      [ngModel]="measure.field || null" (ngModelChange)="measure.field = $event || ''; onLaMeasureChange()"
                    ></ng-select>
                  </div>
                  <div class="control-group">
                    <label>Label</label>
                    <input type="text" [ngModel]="measure.label" (ngModelChange)="measure.label = $event; onLaMeasureChange()" [placeholder]="measure.field || 'Measure'" />
                  </div>
                </div>
                <div class="control-row">
                  <div class="control-group" *ngIf="!(laVariantUsesSeries && laSeries)">
                    <label>Draw as</label>
                    <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="lineAreaRenderTypes" bindLabel="label" bindValue="value" [clearable]="false" [ngModel]="measure.renderAs" (ngModelChange)="measure.renderAs = $event; onLaMeasureChange()"></ng-select>
                  </div>
                  <div class="control-group" *ngIf="!(laVariantUsesSeries && laSeries)">
                    <label>Axis</label>
                    <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="lineAreaAxisOptions" bindLabel="label" bindValue="value" [clearable]="false" [ngModel]="measure.axis" (ngModelChange)="measure.axis = $event; onLaMeasureChange()"></ng-select>
                  </div>
                  <div class="control-group bar-measure-actions" *ngIf="laAllowsMultipleMeasures && laMeasures.length > 1">
                    <button type="button" mat-icon-button (click)="moveLaMeasureUp(i)" [disabled]="first" matTooltip="Move up"><mat-icon>arrow_upward</mat-icon></button>
                    <button type="button" mat-icon-button (click)="moveLaMeasureDown(i)" [disabled]="last" matTooltip="Move down"><mat-icon>arrow_downward</mat-icon></button>
                    <button type="button" mat-icon-button class="row-remove-button" (click)="removeLaMeasure(measure)" matTooltip="Remove measure"><mat-icon>close</mat-icon></button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Reference / target lines. -->
            <div class="wf-subsection-header">
              <span>Reference lines <span class="wf-step-count">{{ laReferenceLines.length }}</span></span>
              <button type="button" class="add-step-button" mat-stroked-button (click)="addLaReferenceLine()"><mat-icon>add</mat-icon> Add line</button>
            </div>
            <div class="bar-refline-list" *ngIf="laReferenceLines.length">
              <div class="control-row bar-refline-row" *ngFor="let line of laReferenceLines">
                <div class="control-group">
                  <label>Value</label>
                  <input type="number" [ngModel]="line.value" (ngModelChange)="line.value = $event; onLaReferenceLineChange()" placeholder="e.g. 100" />
                </div>
                <div class="control-group">
                  <label>Label</label>
                  <input type="text" [ngModel]="line.label" (ngModelChange)="line.label = $event; onLaReferenceLineChange()" placeholder="Target" />
                </div>
                <div class="control-group bar-refline-color">
                  <label>Color</label>
                  <input type="color" [ngModel]="line.color" (ngModelChange)="line.color = $event; onLaReferenceLineChange()" />
                </div>
                <button type="button" mat-icon-button class="bar-refline-remove row-remove-button" (click)="removeLaReferenceLine(line.id)" matTooltip="Remove line"><mat-icon>close</mat-icon></button>
              </div>
            </div>

          </div><!-- /Chart Data body -->
        </div>
      </div>

      <!-- Line & Area options — Title / Axis / Legend / Labels / Tooltip / Formatting /
           Analytics / Interaction / Advanced accordions (shared template). -->
      <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
    </div>

    <!-- ══════════════════ Scatter & Bubble builder ══════════════════
         Mirrors the Bar builder: a family card (variant picker), a Chart-Data
         accordion (X / Y / Size / Color / Series drop-zone pickers), then the
         config-driven Format accordions. Renders client-side via the pure
         scatter-bubble option builder. -->
    <div class="wf-section wf-section-plain" *ngIf="isScatterBubbleLayout">
      <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

      <div class="bridge-chart-settings bar-family-card">
        <div class="bridge-settings-heading"><mat-icon>scatter_plot</mat-icon><span>{{ layoutSectionTitle('scatterBubble', 'Scatter & bubble') }}</span></div>
        <small class="control-hint" *ngIf="layoutSectionHint('scatterBubble')">{{ layoutSectionHint('scatterBubble') }}</small>

        <!-- Orientation segmented toggle — sides are FULLY config-driven
             (scatterBubbleModes: label + icon + value); the Variant dropdown
             below lists only the active side's base variants. -->
        <div class="control-group" *ngIf="fieldEnabled('scatterBubble', 'mode')">
          <label>{{ fieldLabel('scatterBubble', 'mode', 'Orientation') }}</label>
          <div class="wf-step-mode-toggle wf-sb-mode-toggle" role="group" [attr.aria-label]="fieldLabel('scatterBubble', 'mode', 'Orientation')">
            <button type="button" *ngFor="let m of sbModes" [class.is-active]="sbMode === m.value" (click)="setSbMode(m.value)">
              <mat-icon *ngIf="m.icon">{{ m.icon }}</mat-icon> {{ m.label }}
            </button>
          </div>
        </div>

        <!-- Variant — only the active toggle side's BASIC variants (Scatter /
             Multi Scatter, or Bubble / Bubble Matrix); advanced ones live in
             the accordion below. -->
        <div class="control-group" *ngIf="fieldEnabled('scatterBubble', 'variant')">
          <label>{{ fieldLabel('scatterBubble', 'variant', 'Variant') }}</label>
          <ng-select
            #ssSbVariant
            class="ss-select"
            [class.is-open]="!!ssSbVariant.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="sbVariantItems"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngModel]="sbVariant"
            (ngModelChange)="sbVariant = $event; onScatterBubbleChange()"
          ></ng-select>
          <small class="control-hint wf-variant-hint" *ngIf="sbVariantHint">{{ sbVariantHint }}</small>
        </div>

        <!-- Advanced OVERLAYS accordion — Quadrant / Regression / Correlation /
             Cluster Scatter layer ON TOP of the selected base variant (Quadrant
             + Bubble, Regression + Scatter, …). Single-select rows; click the
             active one again to turn the overlay off. -->
        <div class="dvm-format-group wf-sb-advanced" [class.is-open]="sbAdvancedAccordionOpen" *ngIf="fieldEnabled('scatterBubble', 'advanced') && sbAdvancedVariantItems.length">
          <button type="button" class="dvm-format-group-head" (click)="sbAdvancedAccordionOpen = !sbAdvancedAccordionOpen">
            <span>{{ fieldLabel('scatterBubble', 'advanced', 'Multivariate Combinations') }}</span>
            <mat-icon>{{ sbAdvancedAccordionOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="dvm-format-group-body wf-sb-advanced-list" *ngIf="sbAdvancedAccordionOpen">
            <button
              type="button"
              class="wf-sb-advanced-option"
              *ngFor="let v of sbAdvancedVariantItems"
              [class.is-active]="sbAdvanced === v.value"
              (click)="toggleSbAdvanced(v.value)"
            >
              <span class="wf-sb-advanced-label">{{ v.label }}</span>
              <mat-icon *ngIf="sbAdvanced === v.value">check</mat-icon>
            </button>
            <small class="control-hint wf-variant-hint" *ngIf="sbAdvancedHint">{{ sbAdvancedHint }}</small>
          </div>
        </div>
      </div>

      <!-- ══ Chart Data accordion — X / Y / Size / Color / Series ══ -->
      <div class="bar-options-accordion">
        <div class="dvm-format-group" [class.is-open]="sbDataAccordionOpen">
          <button type="button" class="dvm-format-group-head" (click)="sbDataAccordionOpen = !sbDataAccordionOpen">
            <span>Chart Data</span>
            <mat-icon>{{ sbDataAccordionOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="dvm-format-group-body" *ngIf="sbDataAccordionOpen">

            <div class="control-row">
              <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onSbXFieldDrop($event)" title="Drag a column here">
                <label>X axis <span class="wf-axis-hint">— measure</span></label>
                <ng-select
                  #ssSbX class="ss-select" [class.is-open]="!!ssSbX.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="scatterBubbleColumns" [clearable]="false" [searchable]="true"
                  [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  [placeholder]="drillDataset ? 'Pick a column' : 'Select a dataset first'"
                  [ngModel]="sbXField || null" (ngModelChange)="sbXField = $event || ''; onScatterBubbleChange()"
                ></ng-select>
              </div>
              <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onSbYFieldDrop($event)" title="Drag a column here">
                <label>Y axis <span class="wf-axis-hint">— measure</span></label>
                <ng-select
                  #ssSbY class="ss-select" [class.is-open]="!!ssSbY.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="scatterBubbleColumns" [clearable]="false" [searchable]="true"
                  [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  [placeholder]="drillDataset ? 'Pick a column' : 'Select a dataset first'"
                  [ngModel]="sbYField || null" (ngModelChange)="sbYField = $event || ''; onScatterBubbleChange()"
                ></ng-select>
              </div>
            </div>

            <div class="control-row">
              <!-- Size — REQUIRED for Bubble variants only. -->
              <div class="control-group wf-field-drop-zone" [class.is-required-empty]="sbVariantUsesSize && !sbSizeField" *ngIf="sbVariantUsesSize" (dragover)="allowFieldDrop($event)" (drop)="onSbSizeFieldDrop($event)" title="Drag a column here">
                <label>Bubble size <span class="wf-axis-hint">(required)</span></label>
                <ng-select
                  #ssSbSize class="ss-select" [class.is-open]="!!ssSbSize.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="scatterBubbleColumns" [clearable]="false" [searchable]="true"
                  [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  placeholder="Pick a size measure"
                  [ngModel]="sbSizeField || null" (ngModelChange)="sbSizeField = $event || ''; onScatterBubbleChange()"
                ></ng-select>
              </div>
              <!-- Color by — optional. -->
              <div class="control-group wf-field-drop-zone" (dragover)="allowFieldDrop($event)" (drop)="onSbColorFieldDrop($event)" title="Drag a column here">
                <label>Color by <span class="wf-axis-hint">(optional)</span></label>
                <ng-select
                  #ssSbColor class="ss-select" [class.is-open]="!!ssSbColor.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="scatterBubbleColumns" [clearable]="true" [searchable]="true"
                  [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  placeholder="Optional grouping color"
                  [ngModel]="sbColorField || null" (ngModelChange)="sbColorField = $event || ''; onScatterBubbleChange()"
                ></ng-select>
              </div>
            </div>

            <div class="control-row">
              <!-- Series — REQUIRED for Multi Scatter only. -->
              <div class="control-group wf-field-drop-zone" [class.is-required-empty]="sbVariantUsesSeries && !sbSeries" *ngIf="sbVariantUsesSeries" (dragover)="allowFieldDrop($event)" (drop)="onSbSeriesFieldDrop($event)" title="Drag a column here">
                <label>Series / group <span class="wf-axis-hint">(required)</span></label>
                <ng-select
                  #ssSbSeries class="ss-select" [class.is-open]="!!ssSbSeries.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="scatterBubbleColumns" [clearable]="false" [searchable]="true"
                  [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  placeholder="Pick a column to split into series"
                  [ngModel]="sbSeries || null" (ngModelChange)="sbSeries = $event || ''; onScatterBubbleChange()"
                ></ng-select>
              </div>
            </div>

            <div class="control-row">
              <!-- Aggregation — how rows sharing the same X (+ group) roll up. -->
              <div class="control-group" *ngIf="fieldEnabled('scatterBubble', 'aggregation')">
                <label>{{ fieldLabel('scatterBubble', 'aggregation', 'Aggregation') }} <span class="wf-axis-hint">— rows sharing X</span></label>
                <ng-select
                  #ssSbAgg class="ss-select" [class.is-open]="!!ssSbAgg.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="sbAggregationOptions" bindLabel="label" bindValue="value" [clearable]="false"
                  [ngModel]="sbAggregation" (ngModelChange)="sbAggregation = $event; onScatterBubbleChange()"
                ></ng-select>
              </div>
              <!-- Tooltip columns — extra dataset columns shown on hover. -->
              <div class="control-group" *ngIf="fieldEnabled('scatterBubble', 'tooltipColumns')">
                <label>{{ fieldLabel('scatterBubble', 'tooltipColumns', 'Tooltip columns') }} <span class="wf-axis-hint">(optional)</span></label>
                <ng-select
                  #ssSbTooltipCols class="ss-select" [class.is-open]="!!ssSbTooltipCols.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="scatterBubbleColumns" [multiple]="true" [clearable]="true" [searchable]="true"
                  [loading]="isDrillDatasetColumnsLoading" [disabled]="!drillDataset"
                  placeholder="Extra columns on hover"
                  [ngModel]="sbTooltipColumns" (ngModelChange)="sbTooltipColumns = $event || []; onScatterBubbleChange()"
                ></ng-select>
              </div>
            </div>

          </div><!-- /Chart Data body -->
        </div><!-- /Chart Data group -->
      </div><!-- /Chart Data accordion -->

      <!-- Scatter & Bubble Format accordions (config-driven; own sbFormat state). -->
      <div class="bar-options-accordion" *ngIf="scatterBubbleFormatGroups.length">
        <div class="dvm-format-group" *ngFor="let group of scatterBubbleFormatGroups" [class.is-open]="isSbFormatGroupOpen(group.name)">
          <button type="button" class="dvm-format-group-head" (click)="toggleSbFormatGroup(group.name)">
            <span>{{ group.name }}</span>
            <mat-icon>{{ isSbFormatGroupOpen(group.name) ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="dvm-format-group-body" *ngIf="isSbFormatGroupOpen(group.name)">
            <div class="dvm-format-row" *ngFor="let control of group.controls">
              <label>{{ control.label }}</label>
              <input *ngIf="control.control === 'text'" type="text" [ngModel]="sbFormat[control.key]" (ngModelChange)="sbFormat[control.key] = $event; onScatterBubbleFormatChange()" [placeholder]="control.label" />
              <input *ngIf="control.control === 'number'" type="number" [min]="control.min ?? null" [max]="control.max ?? null" [step]="control.step ?? 1" [ngModel]="sbFormat[control.key]" (ngModelChange)="sbFormat[control.key] = $event; onScatterBubbleFormatChange()" />
              <input *ngIf="control.control === 'color'" type="color" [ngModel]="sbFormat[control.key]" (ngModelChange)="sbFormat[control.key] = $event; onScatterBubbleFormatChange()" />
              <label *ngIf="control.control === 'toggle'" class="dvm-format-toggle">
                <input type="checkbox" [ngModel]="sbFormat[control.key]" (ngModelChange)="sbFormat[control.key] = $event; onScatterBubbleFormatChange()" />
              </label>
              <ng-select *ngIf="control.control === 'select'" class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="formatControlOptions(control)" bindLabel="label" bindValue="value" [clearable]="false" [ngModel]="sbFormat[control.key]" (ngModelChange)="sbFormat[control.key] = $event; onScatterBubbleFormatChange()"></ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart format options — SHARED accordion template (rendered for Bar AND
         Waterfall). Config-driven: formatControls filtered to the ACTIVE layout
         type + grouped by `group`; the capabilityRegistry's `sections` list gates
         which accordions appear. Values fold into the tile on Generate. -->
    <ng-template #chartFormatAccordion>
      <div class="bar-options-accordion" *ngIf="barFormatGroups.length">
        <div class="dvm-format-group" *ngFor="let group of barFormatGroups" [class.is-open]="isBarFormatGroupOpen(group.name)">
          <button type="button" class="dvm-format-group-head" (click)="toggleBarFormatGroup(group.name)">
            <span>{{ group.name }}</span>
            <mat-icon>{{ isBarFormatGroupOpen(group.name) ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>

          <div class="dvm-format-group-body" *ngIf="isBarFormatGroupOpen(group.name)">
            <div class="dvm-format-row" *ngFor="let control of group.controls">
              <label>{{ control.label }}</label>

              <input
                *ngIf="control.control === 'text'"
                type="text"
                [ngModel]="barFormat[control.key]"
                (ngModelChange)="barFormat[control.key] = $event; onBarFormatChange()"
                [placeholder]="control.label"
              />

              <input
                *ngIf="control.control === 'number'"
                type="number"
                [min]="control.min ?? null"
                [max]="control.max ?? null"
                [step]="control.step ?? 1"
                [ngModel]="barFormat[control.key]"
                (ngModelChange)="barFormat[control.key] = $event; onBarFormatChange()"
              />

              <input
                *ngIf="control.control === 'color'"
                type="color"
                [ngModel]="barFormat[control.key]"
                (ngModelChange)="barFormat[control.key] = $event; onBarFormatChange()"
              />

              <label *ngIf="control.control === 'toggle'" class="dvm-format-toggle">
                <input
                  type="checkbox"
                  [ngModel]="barFormat[control.key]"
                  (ngModelChange)="barFormat[control.key] = $event; onBarFormatChange()"
                />
              </label>

              <ng-select
                *ngIf="control.control === 'select'"
                class="ss-select"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="formatControlOptions(control)"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [ngModel]="barFormat[control.key]"
                (ngModelChange)="barFormat[control.key] = $event; onBarFormatChange()"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Dropdown control: distinct values from one field become the available
         options and the selected value is applied to the chosen targets. -->
    <div class="wf-section" *ngIf="isDropdownLayout">
      <header class="wf-section-header">
        <h3>{{ layoutSectionTitle('dropdown', 'Dropdown settings') }}</h3>
      </header>
      <small class="control-hint">
        {{ layoutSectionHint('dropdown', 'Choose the field that supplies the options and the dashboard components this dropdown controls.') }}
      </small>
      <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

      <div
        class="control-group control-group-full wf-field-drop-zone"
        *ngIf="fieldEnabled('dropdown', 'field')"
        (dragover)="allowFieldDrop($event)"
        (drop)="onDropdownFieldDrop($event)"
        title="Drag a dataset column here"
      >
        <label>{{ fieldLabel('dropdown', 'field', 'Option field') }}</label>
        <ng-select
          #ssDropdownField
          class="ss-select"
          [class.is-open]="!!ssDropdownField.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="drillDatasetColumns"
          [clearable]="false"
          [searchable]="true"
          [loading]="isDrillDatasetColumnsLoading"
          [disabled]="!drillDataset"
          [placeholder]="drillColumnPlaceholder('dimension')"
          [(ngModel)]="dropdownField"
        ></ng-select>
      </div>

      <div class="control-row">
        <div class="control-group" *ngIf="fieldEnabled('dropdown', 'displayLabel')">
          <label>{{ fieldLabel('dropdown', 'displayLabel', 'Display label') }}</label>
          <input type="text" [(ngModel)]="dropdownDisplayLabel" placeholder="e.g. Region" />
        </div>
        <div class="control-group" *ngIf="fieldEnabled('dropdown', 'defaultValue')">
          <label>{{ fieldLabel('dropdown', 'defaultValue', 'Default value') }}</label>
          <input type="text" [(ngModel)]="dropdownDefaultValue" placeholder="Optional" />
        </div>
      </div>

      <!-- Display as: classic select vs always-visible filter buttons/tiles. -->
      <div class="control-group control-group-full" *ngIf="fieldEnabled('dropdown', 'displayMode')">
        <label>{{ fieldLabel('dropdown', 'displayMode', 'Display as') }}</label>
        <ng-select
          #ssDropdownDisplayMode
          class="ss-select"
          [class.is-open]="!!ssDropdownDisplayMode.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="dropdownDisplayModes"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          [(ngModel)]="dropdownDisplayMode"
        ></ng-select>
      </div>

      <div class="control-group control-group-full" *ngIf="fieldEnabled('dropdown', 'targetCharts')">
        <label>{{ fieldLabel('dropdown', 'targetCharts', 'Target chart(s) / input(s)') }}</label>
        <ng-select
          #ssDropdownTargets
          class="ss-select ss-select--multi ss-select--full"
          [class.is-open]="!!ssDropdownTargets.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="targetCharts"
          bindLabel="label"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [clearable]="true"
          [searchable]="true"
          placeholder="Select the chart(s) or input(s) this dropdown filters"
          [(ngModel)]="selectedTargetCharts"
        ></ng-select>
        <small class="control-hint" *ngIf="!targetCharts.length">Add a chart or input to the dashboard first so it can be selected as a target.</small>
      </div>

      <div class="control-group control-group-full" *ngIf="fieldEnabled('dropdown', 'isMultiSelect')">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="dropdownIsMultiSelect" />
          {{ fieldLabel('dropdown', 'isMultiSelect', 'Allow multiple selections') }}
        </label>
      </div>
      <!-- No Format accordion here by design: Dropdown tiles don't take
           card-header formatting (builder or published). -->
    </div>

    <!-- File upload (FILE_UPLOAD): a standalone uploader whose picked file POSTs
         to the compute API and re-renders the selected target chart(s)/table(s). -->
    <div class="wf-section" *ngIf="isFileUploadLayout">
      <header class="wf-section-header">
        <h3>{{ layoutSectionTitle('upload', 'Upload settings') }}</h3>
      </header>
      <small class="control-hint">{{ layoutSectionHint('upload', 'The uploaded file is sent to the compute API and the response re-renders the selected target(s).') }}</small>

      <div class="control-group control-group-full" *ngIf="fieldEnabled('upload', 'targetCharts')">
        <label>{{ fieldLabel('upload', 'targetCharts', 'Target chart(s) / table(s)') }}</label>
        <ng-select
          #ssUploadTargets
          class="ss-select ss-select--multi ss-select--full"
          [class.is-open]="!!ssUploadTargets.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="targetCharts"
          bindLabel="label"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [clearable]="true"
          [searchable]="true"
          placeholder="Select the chart(s) or table(s) the uploaded file updates"
          [(ngModel)]="selectedTargetCharts"
        ></ng-select>
        <small class="control-hint" *ngIf="!targetCharts.length">Add a chart or table to the dashboard first so it can be selected as a target.</small>
      </div>

      <div class="control-row">
        <div class="control-group" *ngIf="fieldEnabled('upload', 'buttonLabel')">
          <label>{{ fieldLabel('upload', 'buttonLabel', 'Upload button label') }}</label>
          <input type="text" [(ngModel)]="fileUploadButtonLabel" placeholder="Upload file" />
        </div>
        <div class="control-group" *ngIf="fieldEnabled('upload', 'accept')">
          <label>{{ fieldLabel('upload', 'accept', 'Accepted file types') }}</label>
          <input type="text" [(ngModel)]="fileUploadAccept" placeholder=".xlsx,.xls,.csv" />
        </div>
      </div>
      <!-- No Format accordion here by design: File Upload tiles don't take
           card-header formatting (builder or published). -->
    </div>

    <!-- Input controls (INPUT_BOX / SLIDER): a dashboard input that feeds a
         formula/measure value into one or more target charts. -->
    <div class="wf-section" *ngIf="isInputControlLayout">
      <header class="wf-section-header">
        <h3>{{ layoutSectionTitle('input', isSliderLayout ? 'Slider input' : 'Input box') }}</h3>
      </header>
      <small class="control-hint">{{ layoutSectionHint('input', 'This control feeds its value into the target chart(s) selected below.') }}</small>

      <div class="control-group control-group-full" *ngIf="fieldEnabled('input', 'targetCharts')">
        <label>{{ fieldLabel('input', 'targetCharts', 'Target chart(s) / input(s)') }}</label>
        <ng-select
          #ssInputTargets
          class="ss-select ss-select--multi ss-select--full"
          [class.is-open]="!!ssInputTargets.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="targetCharts"
          bindLabel="label"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [clearable]="true"
          [searchable]="true"
          placeholder="Select the chart(s) or input(s) this control drives"
          [(ngModel)]="selectedTargetCharts"
        ></ng-select>
        <small class="control-hint" *ngIf="!targetCharts.length">Add charts or other inputs to the dashboard first — they'll appear here as targets.</small>
      </div>

      <!-- Per-target formula: each selected target gets its own expression fed by
           this control's `value` (e.g. KPI: [price] * value; another input:
           value * 2). A WATERFALL target instead lists one formula per bridge
           step, since each bar is independently calculated. Each row is a drop
           zone — drag a column from the Data pane to add its token. -->
      <div class="control-group control-group-full" *ngIf="selectedTargetCharts.length">
        <label>{{ fieldLabel('input', 'formula', 'Formula per target') }}</label>
        <ng-container *ngFor="let id of selectedTargetCharts">
          <div class="target-formula-group" *ngIf="isWaterfallTarget(id)">
            <span class="target-formula-name" [title]="targetLabelForId(id)">{{ targetLabelForId(id) }} — per bar</span>
            <div class="target-formula-bar" *ngFor="let step of targetSteps(id); trackBy: trackByStepLabel">
              <div
                class="target-formula-row wf-field-drop-zone"
                (dragover)="allowFieldDrop($event)"
                (drop)="onTargetFormulaDrop($event, id, step.label)"
                title="Drag a column here to add it to this bar's formula"
              >
                <span class="target-formula-name" [title]="step.label">{{ step.label || step.stepType }}</span>
                <input
                  type="text"
                  [ngModel]="targetStepFormula(id, step.label)"
                  (ngModelChange)="setTargetStepFormula(id, step.label, $event)"
                  placeholder="e.g. [price] * value"
                />
              </div>

              <!-- This bar's own references — same [Token] mechanism as below,
                   scoped to THIS bar's formula only. -->
              <ng-container *ngIf="formulaReferencesEnabledFor('WATERFALL')">
                <ng-container
                  *ngTemplateOutlet="referenceList; context: { id: id, step: step.label }"
                ></ng-container>
              </ng-container>
            </div>
          </div>
          <div *ngIf="!isWaterfallTarget(id)">
            <div
              class="target-formula-row wf-field-drop-zone"
              (dragover)="allowFieldDrop($event)"
              (drop)="onTargetFormulaDrop($event, id)"
              title="Drag a column here to add it to this target's formula"
            >
              <span class="target-formula-name" [title]="targetLabelForId(id)">{{ targetLabelForId(id) }}</span>
              <input
                type="text"
                [ngModel]="targetFormulas[id] || ''"
                (ngModelChange)="targetFormulas[id] = $event"
                [placeholder]="isInputControlTargetId(id) ? 'value (default — passes this control’s value through)' : 'e.g. [price] * value'"
              />
            </div>
            <!-- A CHART target with no formula is silently skipped by the
                 recompute (nothing to calculate) — surface that instead. -->
            <small class="control-warning" *ngIf="!isInputControlTargetId(id) && !(targetFormulas[id] || '').trim()">
              No formula yet — "{{ targetLabelForId(id) }}" will NOT update when this control changes. Add one, e.g. [{{ targetLabelForId(id) }}]*(1+(value/100))
            </small>

            <!-- References: when a formula's [Token] isn't a plain dataset
                 column but another input's live/recomputed output (e.g. a row
                 inside a different target chart), type in where it actually
                 comes from so the backend resolves the CURRENT value instead
                 of a stale one. Fully typed by hand — no drag-and-drop. -->
            <ng-container *ngIf="formulaReferencesEnabledFor(targetLayoutTypeForId(id))">
              <ng-container
                *ngTemplateOutlet="referenceList; context: { id: id }"
              ></ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="control-row" *ngIf="isSliderLayout && (fieldEnabled('input', 'min') || fieldEnabled('input', 'max') || fieldEnabled('input', 'step'))">
        <div class="control-group" *ngIf="fieldEnabled('input', 'min')">
          <label>{{ fieldLabel('input', 'min', 'Min') }}</label>
          <input type="number" [(ngModel)]="sliderMin" />
        </div>
        <div class="control-group" *ngIf="fieldEnabled('input', 'max')">
          <label>{{ fieldLabel('input', 'max', 'Max') }}</label>
          <input type="number" [(ngModel)]="sliderMax" />
        </div>
        <div class="control-group" *ngIf="fieldEnabled('input', 'step')">
          <label>{{ fieldLabel('input', 'step', 'Step') }}</label>
          <input type="number" [(ngModel)]="sliderStep" />
        </div>
      </div>

      <div class="control-group control-group-full" *ngIf="fieldEnabled('input', 'defaultValue')">
        <label>{{ fieldLabel('input', 'defaultValue', 'Default value') }}</label>
        <input
          type="number"
          [(ngModel)]="inputDefaultValue"
          [placeholder]="isSliderLayout ? 'Handle start position (optional)' : 'Pre-filled value (optional)'"
        />
      </div>
      <!-- No Format accordion here by design: Slider / Input Box tiles don't
           take card-header formatting (builder or published). -->
    </div>

    <!-- Chart interactions: besides filterKey/filterListeners, a CHART can name
         the component(s) it interacts with. Persisted as payload.targets (same
         shape the input controls use, minus per-target formulas) — also
         editable later from the tile header's link icon. OPTIONAL, so it lives
         in a collapsed accordion (steps/axes stay always visible — those are
         required); the badge shows how many targets are wired. -->
    <div class="tm-nav-config" *ngIf="isChartTargetLayout">
      <div class="tm-nav-head" (click)="interactionsSectionOpen = !interactionsSectionOpen">
        <mat-icon>{{ interactionsSectionOpen ? 'expand_more' : 'chevron_right' }}</mat-icon>
        <span>{{ layoutSectionTitle('interactions', 'Chart interactions') }}</span>
        <span class="tm-nav-badge" *ngIf="selectedTargetCharts.length">{{ selectedTargetCharts.length }}</span>
      </div>
      <div class="tm-nav-body" *ngIf="interactionsSectionOpen">
        <small class="control-hint">
          {{ layoutSectionHint('interactions', 'Select the chart(s)/input(s) this chart interacts with — its interactions are sent to these targets.') }}
        </small>
        <div class="control-group control-group-full">
          <label>{{ fieldLabel('interactions', 'targetCharts', 'Target chart(s) / input(s)') }}</label>
          <ng-select
            #ssChartTargets
            class="ss-select ss-select--multi ss-select--full"
            [class.is-open]="!!ssChartTargets.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="targetCharts"
            bindLabel="label"
            bindValue="value"
            [multiple]="true"
            [closeOnSelect]="false"
            [hideSelected]="false"
            [clearable]="true"
            [searchable]="true"
            placeholder="Select target chart(s)/input(s)"
            [(ngModel)]="selectedTargetCharts"
          ></ng-select>
          <small class="control-hint" *ngIf="!targetCharts.length">Add more charts or inputs to the dashboard first — they'll appear here as targets.</small>
        </div>
      </div>
    </div>

    <!-- Drill-Down: its format accordions (Formatting / Columns / Drill-Down)
         render HERE — below the Hierarchy dimensions / Measures / Chart-
         interactions block — so the required hierarchy mapping stays at the top
         and the optional formatting sits after the interactions accordion. -->
    <ng-container *ngIf="isTableMatrixLayout && isTmDrilldown" [ngTemplateOutlet]="chartFormatAccordion"></ng-container>

    <div class="wf-generate-row">
      <button type="button" class="primary-action" [disabled]="!canGenerate" (click)="generateConfiguration()">
        {{ isGenerating ? (editingTileId ? 'Updating...' : 'Generating...') : (editingTileId ? 'Update Configuration' : 'Generate Configuration') }}
      </button>
      <div class="message warning-message" *ngIf="generateError">{{ generateError }}</div>
    </div>
    </div>
  </aside>

  <div class="pane-resizer steps-pane-resizer" [class.is-disabled]="isDividerDisabled(0)" (mousedown)="startDividerResize(0, $event)" aria-hidden="true"></div>

  <!-- ══════════════════ RIGHT: dynamic preview canvas ══════════════════ -->
  <!-- ══════════════════ RIGHT: dashboard preview canvas ══════════════════ -->
  <div
    class="dvm-layout-preview-panel"
    [class.is-collapsed]="previewPanelCollapsed"
    [class.is-fullscreen]="isDashboardFullscreen"
    [style.grid-column]="paneGridColumn('preview')"
    (dragover)="onPaneDragOver($event)"
    (drop)="onPaneDrop('preview', $event)"
  >
    <button
      *ngIf="previewPanelCollapsed"
      type="button"
      class="collapsed-preview-reopen"
      mat-icon-button
      (mousedown)="$event.stopPropagation()"
      (click)="$event.stopPropagation(); previewPanelCollapsed = false"
      matTooltip="Open dashboard"
      aria-label="Open dashboard panel"
    ><mat-icon>{{ paneCollapseIcon('preview') }}</mat-icon></button>
    <div class="wf-preview-header">
      <span *ngIf="!isDashboardFullscreen" class="pane-drag-handle preview-drag-grip" draggable="true" (dragstart)="onPaneDragStart('preview', $event)" (dragend)="onPaneDragEnd()" matTooltip="Drag to reorder panel"><mat-icon>drag_indicator</mat-icon></span>
      <div class="dvm-dashboard-titlebar">
        <span class="wf-section-kicker">Dashboard</span>
        <input class="dvm-dashboard-name" type="text" [(ngModel)]="dashboardName" placeholder="Untitled dashboard" aria-label="Dashboard name" />
      </div>
      <span class="wf-step-count dvm-tile-count">{{ dashboardTiles.length }} chart{{ dashboardTiles.length === 1 ? '' : 's' }}</span>

      <div class="dvm-preview-actions">
        <!-- Full-screen preview: a single Back button to return to the builder. -->
        <button *ngIf="isDashboardFullscreen" type="button" class="add-step-button dvm-back-button" mat-flat-button color="primary" (click)="toggleDashboardFullscreen()" matTooltip="Back to builder">
          <mat-icon>arrow_back</mat-icon> Back
        </button>
        <button *ngIf="isDashboardFullscreen" type="button" class="add-step-button" mat-stroked-button [class.is-active]="previewEditLayout" (click)="previewEditLayout = !previewEditLayout" [matTooltip]="previewEditLayout ? 'Done editing layout' : 'Rearrange / resize the tiles'">
          <mat-icon>{{ previewEditLayout ? 'done' : 'dashboard_customize' }}</mat-icon> {{ previewEditLayout ? 'Done' : 'Edit Layout' }}
        </button>
        <!-- <button *ngIf="isDashboardFullscreen" type="button" class="add-step-button" mat-stroked-button [disabled]="!canSaveDashboard" (click)="saveDashboard()" matTooltip="Save this dashboard draft">
          <mat-icon>save</mat-icon> {{ isSavingDashboard ? 'Saving…' : 'Save' }}
        </button> -->
        <button *ngIf="isDashboardFullscreen" type="button" class="add-step-button dvm-publish-button" mat-flat-button color="primary" [disabled]="!canPublish" (click)="publishDashboard()" [matTooltip]="isExistingPublishedDashboard ? 'Update the published dashboard' : 'Publish the dashboard to the left menu'">
          <mat-icon>{{ isExistingPublishedDashboard ? 'sync' : 'publish' }}</mat-icon> {{ publishButtonLabel }}
        </button>

        <ng-container *ngIf="!isDashboardFullscreen">
          <button type="button" class="add-step-button" mat-stroked-button (click)="startNewChart()" matTooltip="Clear the builder to start a new chart"><mat-icon>add</mat-icon> New chart</button>
          <button type="button" class="add-step-button" mat-stroked-button [disabled]="!dashboardTiles.length && !dashboardName.trim()" (click)="startNewDashboard()" matTooltip="Clear all charts and start a fresh dashboard"><mat-icon>note_add</mat-icon> New dashboard</button>
          <button type="button" class="add-step-button" mat-stroked-button [disabled]="dashboardTiles.length < 2" [class.is-active]="groupSelectMode" (click)="toggleGroupSelectMode()" [matTooltip]="groupSelectMode ? 'Cancel selecting charts to group' : 'Select charts to club into one card'">
            <mat-icon>{{ groupSelectMode ? 'close' : 'select_all' }}</mat-icon> {{ groupSelectMode ? 'Cancel' : 'Group charts' }}
          </button>
          <button *ngIf="groupSelectMode" type="button" class="add-step-button dvm-publish-button" mat-flat-button color="primary" [disabled]="!canGroupSelectedTiles" (click)="groupSelectedTiles()" matTooltip="Club the selected charts into one titled card">
            <mat-icon>dashboard_customize</mat-icon> Group ({{ selectedTileIds.size }})
          </button>
          <!-- <button type="button" class="add-step-button" mat-stroked-button [disabled]="!dashboardTiles.length" (click)="toggleDashboardFullscreen()" matTooltip="Preview full screen">
            <mat-icon>fullscreen</mat-icon> Preview
          </button> -->
          <!-- <button type="button" class="add-step-button" mat-stroked-button [disabled]="!canSaveDashboard" (click)="saveDashboard()" matTooltip="Save this dashboard draft">
            <mat-icon>save</mat-icon> {{ isSavingDashboard ? 'Saving…' : 'Save' }}
          </button> -->
          <button type="button" class="add-step-button dvm-publish-button" mat-flat-button color="primary" [disabled]="!canPublish" (click)="publishDashboard()" [matTooltip]="isExistingPublishedDashboard ? 'Update the published dashboard' : 'Publish the dashboard to the left menu'">
            <mat-icon>{{ isExistingPublishedDashboard ? 'sync' : 'publish' }}</mat-icon> {{ publishButtonLabel }}
          </button>
          <button
            type="button"
            class="panel-collapse-button preview-collapse-button"
            [class.is-hidden-when-collapsed]="previewPanelCollapsed"
            mat-icon-button
            (click)="previewPanelCollapsed = !previewPanelCollapsed"
            [matTooltip]="previewPanelCollapsed ? 'Open dashboard' : 'Collapse dashboard'"
            [attr.aria-label]="previewPanelCollapsed ? 'Open dashboard panel' : 'Collapse dashboard panel'"
          ><mat-icon>{{ paneCollapseIcon('preview') }}</mat-icon></button>
        </ng-container>
      </div>
    </div>

    <div class="preview-panel-content panel-content">
      <div class="dvm-dashboard-canvas" #dashboardCanvas>
        <!-- Active cross-filter chip: shows what a bar-click filtered the other
             tiles by, with a Clear button to reset. -->
        <div class="dvm-crossfilter-chip" *ngIf="activeCrossFilter">
          <mat-icon>filter_alt</mat-icon>
          <span>Filtered: <strong>{{ activeCrossFilter.column }}</strong> = <strong>{{ activeCrossFilter.values.join(', ') }}</strong></span>
          <button type="button" mat-icon-button matTooltip="Clear filter" (click)="clearCrossFilter()"><mat-icon>close</mat-icon></button>
        </div>

        <div class="empty-state dvm-canvas-empty" *ngIf="!dashboardTiles.length">
          <div class="empty-state-icon"><mat-icon>dashboard</mat-icon></div>
          <p>Name your dashboard, build a chart on the left,<br />and click <strong>Generate Configuration</strong><br />to add it here. Drag a tile to reorder, drag a corner to resize.</p>
        </div>

        <!-- Reusable Format popup body (JSON-driven controls) — used for a normal
             top-level tile AND for each member inside a GROUP card, so a grouped
             chart keeps its own independent Format popup, same as before. -->
        <ng-template #formatPopup let-tile="tile">
          <div class="dvm-format-popup-head">
            <span>Format</span>
            <button type="button" mat-icon-button (click)="toggleTileFormat(tile, $event)" aria-label="Close"><mat-icon>close</mat-icon></button>
          </div>
          <div class="dvm-format-popup-body">
            <!-- Accordion sections: Title / Axis / Tooltip / Formatting / Advanced
                 (grouped by each control's `group`, JSON-driven). -->
            <div class="dvm-format-group" *ngFor="let group of formatGroupsFor(tile); let gi = index" [class.is-open]="isFormatGroupOpen(tile, group.name, gi)">
              <button type="button" class="dvm-format-group-head" (click)="toggleFormatGroup(tile, group.name, gi)">
                <span>{{ group.name }}</span>
                <mat-icon>{{ isFormatGroupOpen(tile, group.name, gi) ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>

              <div class="dvm-format-group-body" *ngIf="isFormatGroupOpen(tile, group.name, gi)">
                <div class="dvm-format-row" *ngFor="let control of group.controls">
                  <label>{{ control.label }}</label>

                  <input
                    *ngIf="control.control === 'text'"
                    type="text"
                    [ngModel]="tile.format[control.key]"
                    (ngModelChange)="tile.format[control.key] = $event; onTileFormatChange(tile)"
                    [placeholder]="control.key === 'title' ? tile.title : (control.placeholder || '')"
                  />

                  <input
                    *ngIf="control.control === 'number'"
                    type="number"
                    [min]="control.min ?? null"
                    [max]="control.max ?? null"
                    [step]="control.step ?? 1"
                    [ngModel]="tile.format[control.key]"
                    (ngModelChange)="tile.format[control.key] = $event; onTileFormatChange(tile)"
                  />

                  <input
                    *ngIf="control.control === 'color'"
                    type="color"
                    [ngModel]="tile.format[control.key]"
                    (ngModelChange)="tile.format[control.key] = $event; onTileFormatChange(tile)"
                  />

                  <label *ngIf="control.control === 'toggle'" class="dvm-format-toggle">
                    <input
                      type="checkbox"
                      [ngModel]="tile.format[control.key]"
                      (ngModelChange)="tile.format[control.key] = $event; onTileFormatChange(tile)"
                    />
                  </label>

                  <ng-select
                    *ngIf="control.control === 'select'"
                    class="ss-select"
                    appendTo="body"
                    ngClass="ss-dropdown-panel"
                    [items]="formatControlOptions(control)"
                    bindLabel="label"
                    bindValue="value"
                    [clearable]="false"
                    [ngModel]="tile.format[control.key]"
                    (ngModelChange)="tile.format[control.key] = $event; onTileFormatChange(tile); openFormatTileId = null"
                  ></ng-select>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <!-- Reusable "render this tile's actual chart" block — used for a normal
             top-level tile AND for each member inside a GROUP card, so grouping
             never needs a second copy of the per-type render logic. -->
        <ng-template #tileBody let-tile="tile">
          <!-- Waterfall -->
          <app-waterfall-chart *ngIf="tile.waterfallData" class="dvm-tile-chart" [data]="tile.waterfallData" (crossFilterChange)="onTileCrossFilter(tile, $event)"></app-waterfall-chart>

          <!-- Drill-down table -->
          <lib-drill-down *ngIf="tile.drillData" [data]="tile.drillData"></lib-drill-down>

          <!-- Table & Matrix (Normal / Editable / Drill-Down) -->
          <app-unified-table-matrix-chart
            *ngIf="tile.tableMatrixData"
            class="dvm-tile-chart"
            [data]="tile.tableMatrixData"
            (crossFilterChange)="onTileCrossFilter(tile, $event)"
            (navigate)="onTileNavigate(tile, $event)"
            (refresh)="onTileTableRefresh(tile)"
            (columnOrderChange)="onTileColumnReorder(tile, $event)"
          ></app-unified-table-matrix-chart>

          <!-- Horizontal bar chart -->
          <app-horizontal-bar-chart *ngIf="tile.hbData" [data]="tile.hbData"></app-horizontal-bar-chart>

          <!-- Unified Bar & Column chart (Simple/Grouped/Stacked/100%/Clustered, H/V) -->
          <app-unified-bar-column-chart *ngIf="tile.barData" class="dvm-tile-chart" [data]="tile.barData" (crossFilterChange)="onTileCrossFilter(tile, $event)"></app-unified-bar-column-chart>

          <!-- Unified Line & Area chart (Line/Multi/Step/Spline; Area/Stacked/100%; analytics) -->
          <app-unified-line-area-chart *ngIf="tile.lineAreaData" class="dvm-tile-chart" [data]="tile.lineAreaData" (crossFilterChange)="onTileCrossFilter(tile, $event)"></app-unified-line-area-chart>

          <!-- Unified Scatter & Bubble chart (Scatter / Multi / Bubble / Quadrant) -->
          <app-unified-scatter-bubble-chart *ngIf="tile.scatterBubbleData" class="dvm-tile-chart" [data]="tile.scatterBubbleData" (crossFilterChange)="onTileCrossFilter(tile, $event)"></app-unified-scatter-bubble-chart>

          <!-- KPI card -->
          <app-number-stats-shared *ngIf="tile.kpiData" [data]="tile.kpiData"></app-number-stats-shared>

          <!-- Dataset-backed dropdown input. -->
          <div class="dvm-tile-input" *ngIf="tile.dropdownControl">
            <app-global-dropdown
              [data]="tile.dropdownControl.widgetData"
              [options]="tile.dropdownControl.options"
              [ngModel]="tile.dropdownControl.value"
              (ngModelChange)="onTileDropdownChange(tile, $event)"
            ></app-global-dropdown>
            <small class="control-hint" *ngIf="tile.dropdownControl.targets.length">
              Filters {{ tile.dropdownControl.targets.length }} target(s).
            </small>
          </div>

          <!-- Input control (slider / input box) — reuses the shared widgets. -->
          <div class="dvm-tile-input" *ngIf="tile.inputControl">
            <app-mat-slider
              *ngIf="tile.inputControl.kind === 'SLIDER'"
              [data]="tile.inputControl.widgetData"
              (valueChange)="onTileSliderChange(tile, $event)"
            ></app-mat-slider>
            <app-input-box
              *ngIf="tile.inputControl.kind === 'INPUT_BOX'"
              [data]="tile.inputControl.widgetData"
              (valueChange)="onTileInputValueChange(tile, $event)"
            ></app-input-box>
            <small class="control-hint" *ngIf="tile.inputControl.targets.length">
              Drives {{ tile.inputControl.targets.length }} chart(s) with per-target formulas.
            </small>
          </div>

          <!-- File upload control — reusable uploader; the picked file POSTs to
               compute + drives targets (handled by onTileFileSelected). -->
          <div class="dvm-tile-input dvm-tile-upload" *ngIf="tile.fileUploadControl">
            <app-dvm-file-upload
              [title]="tile.title"
              [buttonLabel]="tile.fileUploadControl.buttonLabel"
              [accept]="tile.fileUploadControl.accept"
              [uploading]="isTileUploading(tile)"
              [message]="tileUploadMessage(tile)"
              [targetCount]="tile.fileUploadControl.targets.length"
              (filePicked)="onTileFilePicked(tile, $event)"
            ></app-dvm-file-upload>
          </div>
        </ng-template>

        <div
          class="dvm-dashboard-tile"
          [class.is-group-tile]="tile.layoutType === 'GROUP'"
          [ngStyle]="groupCardStyles(tile)"
          *ngFor="let tile of dashboardTiles; let i = index; trackBy: trackTileById"
          [class.is-drop-target]="tileDragIndex !== null && tileDragIndex !== i"
          [class.is-formatting]="openFormatTileId === tile.id"
          [style.--dvm-card-header-bg]="isFormattableTile(tile) ? (tile.format?.['cardHeaderBackground'] || null) : null"
          [style.--dvm-card-header-color]="isFormattableTile(tile) ? (tile.format?.['cardHeaderColor'] || null) : null"
          [style.--dvm-card-header-align]="isFormattableTile(tile) ? (tile.format?.['titleAlign'] || null) : null"
          [class.dvm-tile-no-header-format]="!isFormattableTile(tile)"
          [class.is-selectable]="groupSelectMode && tile.layoutType !== 'GROUP'"
          [class.is-selected]="isTileSelected(tile)"
          [style.grid-column]="'span ' + tile.colSpan"
          [style.grid-row]="'span ' + tile.rowSpan"
          (dragover)="onTileReorderOver($event)"
          (drop)="onTileReorderDrop(i, $event)"
          (click)="groupSelectMode && tile.layoutType !== 'GROUP' ? toggleTileSelected(tile) : null"
        >
          <!-- Recompute overlay — shown ONLY on the tile(s) this input control
               targets while its recompute POST is in flight, not the whole canvas. -->
          <div class="dvm-recompute-overlay" *ngIf="isTileRecomputing(tile)">
            <span class="dvm-recompute-spinner" aria-hidden="true"></span>
          </div>
          <!-- Builder chrome (grip / title / type badge / format / remove) is
               hidden in Preview so the tile renders as the clean published card —
               unless "Edit Layout" is toggled on to rearrange/resize the tiles. -->
          <div
            *ngIf="!isDashboardFullscreen || previewEditLayout"
            class="dvm-tile-header"
            draggable="true"
            (dragstart)="onTileReorderStart(i, $event)"
            (dragend)="onTileReorderEnd()"
            matTooltip=""
          >
            <input
              *ngIf="groupSelectMode && tile.layoutType !== 'GROUP'"
              type="checkbox"
              class="dvm-tile-select-check"
              [checked]="isTileSelected(tile)"
              (click)="$event.stopPropagation()"
              (change)="toggleTileSelected(tile)"
              aria-label="Select chart to group"
            />
            <span *ngIf="tile.layoutType !== 'GROUP'" class="dvm-tile-title" [title]="tile.title | capitalCase">{{ tile.title | capitalCase }}</span>
            <input
              *ngIf="tile.layoutType === 'GROUP'"
              type="text"
              class="dvm-tile-title dvm-group-title-input"
              [(ngModel)]="tile.groupTitle"
              (click)="$event.stopPropagation()"
              placeholder="Group card title"
            />
            <!-- Actions overlay the right edge and appear on tile hover, so the
                 title keeps the full header width on narrow tiles. -->
            <div class="dvm-tile-actions">
              <button
                *ngIf="tile.layoutType !== 'GROUP'"
                type="button"
                mat-icon-button
                class="dvm-tile-edit"
                [class.is-active]="editingTileId === tile.id"
                (click)="editTile(tile, $event)"
                matTooltip="Edit chart configuration"
                aria-label="Edit chart configuration"
              >
                <mat-icon>edit</mat-icon>
              </button>
            <!-- Cross-filter listener editor — publishes a filter key + picks which
                 tiles react. Shown for any registered client-side chart tile
                 (registry-driven, so Pie/Line/… get it automatically) plus
                 source-only publishers like the waterfall. -->
            <button
              *ngIf="canConfigureCrossFilter(tile)"
              type="button"
              mat-icon-button
              class="dvm-tile-filter"
              [class.is-active]="expandedListenerTileId === tile.id"
              (click)="toggleListenerEditor(tile, $event)"
              matTooltip="Cross-filter (publishes filter key)"
              aria-label="Cross-filter settings"
            >
              <mat-icon>filter_alt</mat-icon>
            </button>
              <button
                *ngIf="isFormattableTile(tile)"
                type="button"
                mat-icon-button
                class="dvm-tile-format"
                [class.is-active]="openFormatTileId === tile.id"
                (click)="toggleTileFormat(tile, $event)"
                matTooltip="Format chart"
                aria-label="Format chart"
              >
                <mat-icon>tune</mat-icon>
              </button>
              <button
                *ngIf="canEditInteractions(tile)"
                type="button"
                mat-icon-button
                class="dvm-tile-interactions"
                [class.is-active]="openInteractionTileId === tile.id"
                (click)="toggleTileInteractions(tile, $event)"
                matTooltip="Chart interactions (targets & references)"
                aria-label="Edit chart interactions"
              >
                <mat-icon>link</mat-icon>
              </button>
              <button *ngIf="tile.layoutType === 'GROUP'" type="button" mat-icon-button class="dvm-tile-columns" (click)="toggleGroupColumns(tile); $event.stopPropagation()" [matTooltip]="(tile.groupColumns || 1) >= 2 ? 'Switch to 1 column' : 'Switch to 2 columns'" aria-label="Toggle group columns">
                <mat-icon>{{ (tile.groupColumns || 1) >= 2 ? 'view_agenda' : 'view_column' }}</mat-icon>
              </button>
              <button *ngIf="tile.layoutType === 'GROUP'" type="button" mat-icon-button class="dvm-tile-ungroup" (click)="ungroupTile(tile); $event.stopPropagation()" matTooltip="Ungroup — restore as separate charts" aria-label="Ungroup">
                <mat-icon>call_split</mat-icon>
              </button>
              <button type="button" mat-icon-button class="dvm-tile-remove" (click)="removeTile(tile)" matTooltip="Remove from dashboard" aria-label="Remove tile">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <!-- Per-tile Format popup (JSON-driven controls). -->
          <div class="dvm-tile-format-popup" [class.align-left]="formatPopupAlign === 'left'" *ngIf="openFormatTileId === tile.id && tile.format">
            <ng-container *ngTemplateOutlet="formatPopup; context: { tile: tile }"></ng-container>
          </div>

          <!-- Cross-filter listener editor (mirrors the dashboard-builder): the
               column this tile PUBLISHES on click + which tiles REACT to it. -->
          <div class="dvm-listener-editor" *ngIf="expandedListenerTileId === tile.id">
            <div class="dvm-listener-row">
              <label>Publishes filter key</label>
              <ng-select
                #ssTileFilterKey
                class="ss-select"
                [class.is-open]="!!ssTileFilterKey.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="tileFilterColumns(tile)"
                [clearable]="true"
                [searchable]="true"
                placeholder="(defaults to the category column)"
                [ngModel]="effectiveTileFilterKey(tile) || null"
                (ngModelChange)="setTileFilterKey(tile, $event || '')"
                (clear)="setTileFilterKey(tile, '')"
              ></ng-select>
            </div>
            <div class="dvm-listener-row">
              <label>Components that react to this card</label>
              <div class="dvm-listener-checkboxes" *ngIf="reactableTilesFor(tile).length; else noOtherTiles">
                <label class="dvm-listener-checkbox" *ngFor="let target of reactableTilesFor(tile)">
                  <input
                    type="checkbox"
                    [checked]="isTileListener(tile, target.id)"
                    (change)="toggleTileListener(tile, target.id)"
                  />
                  <span>{{ target.title || target.layoutType }} <small>({{ target.layoutType | lowercase }})</small></span>
                </label>
              </div>
              <ng-template #noOtherTiles>
                <small class="control-hint">Add more charts to wire cross-filter listeners.</small>
              </ng-template>
            </div>
            <div class="dvm-listener-actions">
              <button type="button" class="dvm-listener-reset" (click)="resetTileListeners(tile)">Reset to chart defaults</button>
              <button type="button" class="dvm-listener-done" (click)="toggleListenerEditor(tile)">Done</button>
            </div>
          </div>

          <div class="dvm-tile-body" *ngIf="tile.layoutType !== 'GROUP'">
            <ng-container *ngTemplateOutlet="tileBody; context: { tile: tile }"></ng-container>
          </div>

          <!-- GROUP card: members stack inside, each keeping its OWN render AND
               its own Edit/Format/Interactions — grouping only changes WHERE a
               chart renders, not what you can still do to it individually. -->
          <div class="dvm-group-body" [class.two-col]="(tile.groupColumns || 1) >= 2" *ngIf="tile.layoutType === 'GROUP'">
            <div class="dvm-group-empty" *ngIf="!tile.groupMembers?.length">Empty group — ungroup or remove it.</div>
            <div class="dvm-group-member" [class.is-formatting]="openFormatTileId === member.id" *ngFor="let member of tile.groupMembers" [style.--dvm-card-header-align]="member.format?.['titleAlign'] || null">
              <div class="dvm-group-member-head">
                <span [title]="member.title">{{ member.title }}</span>
                <div class="dvm-group-member-actions">
                  <!-- Order inside the card IS the layout: members render (and
                       publish) in this sequence, so these move the chart within
                       the group. -->
                  <button type="button" mat-icon-button class="dvm-group-member-move"
                          [disabled]="!canMoveGroupMember(tile, member, -1)"
                          (click)="moveGroupMember(tile, member, -1, $event)"
                          matTooltip="Move earlier in the card" aria-label="Move earlier in the card">
                    <mat-icon>arrow_upward</mat-icon>
                  </button>
                  <button type="button" mat-icon-button class="dvm-group-member-move"
                          [disabled]="!canMoveGroupMember(tile, member, 1)"
                          (click)="moveGroupMember(tile, member, 1, $event)"
                          matTooltip="Move later in the card" aria-label="Move later in the card">
                    <mat-icon>arrow_downward</mat-icon>
                  </button>
                  <button type="button" mat-icon-button [class.is-active]="editingTileId === member.id" (click)="editTile(member, $event)" matTooltip="Edit chart configuration" aria-label="Edit chart configuration">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button *ngIf="isFormattableTile(member)" type="button" mat-icon-button [class.is-active]="openFormatTileId === member.id" (click)="toggleTileFormat(member, $event)" matTooltip="Format chart" aria-label="Format chart">
                    <mat-icon>tune</mat-icon>
                  </button>
                  <button *ngIf="canEditInteractions(member)" type="button" mat-icon-button [class.is-active]="openInteractionTileId === member.id" (click)="toggleTileInteractions(member, $event)" matTooltip="Chart interactions (targets & references)" aria-label="Edit chart interactions">
                    <mat-icon>link</mat-icon>
                  </button>
                  <button type="button" mat-icon-button (click)="removeGroupMember(tile, member)" matTooltip="Remove from group" aria-label="Remove from group">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
              <div class="dvm-tile-format-popup dvm-group-member-format-popup" [class.align-left]="formatPopupAlign === 'left'" *ngIf="openFormatTileId === member.id && member.format">
                <ng-container *ngTemplateOutlet="formatPopup; context: { tile: member }"></ng-container>
              </div>
              <div class="dvm-tile-body dvm-group-member-body">
                <ng-container *ngTemplateOutlet="tileBody; context: { tile: member }"></ng-container>
              </div>
            </div>
          </div>

          <span *ngIf="!isDashboardFullscreen || previewEditLayout" class="dvm-tile-resize" (mousedown)="startTileResize(tile, $event)" matTooltip="Drag to resize" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="pane-resizer pane-resizer--data" [class.is-disabled]="isDividerDisabled(1)" (mousedown)="startDividerResize(1, $event)" aria-hidden="true"></div>

  <aside class="dvm-layout-data-panel wf-section" [class.is-collapsed]="dataPanelCollapsed" [style.grid-column]="paneGridColumn('data')" (dragover)="onPaneDragOver($event)" (drop)="onPaneDrop('data', $event)">
    <header class="wf-section-header data-panel-header pane-drag-handle" draggable="true" (dragstart)="onPaneDragStart('data', $event)" (dragend)="onPaneDragEnd()" matTooltip="Drag to reorder panel">
      <div><span class="wf-section-kicker">Data explorer</span><h3>Tables &amp; fields</h3></div>
      <div class="wf-header-actions">
        <mat-icon matTooltip="Drag a field onto a bridge step">dataset</mat-icon>
        <button
          type="button"
          class="panel-collapse-button"
          mat-icon-button
          (click)="dataPanelCollapsed = !dataPanelCollapsed"
          [matTooltip]="dataPanelCollapsed ? 'Open data' : 'Collapse data'"
          [attr.aria-label]="dataPanelCollapsed ? 'Open data panel' : 'Collapse data panel'"
        ><mat-icon>{{ paneCollapseIcon('data') }}</mat-icon></button>
      </div>
    </header>

    <div class="data-panel-content panel-content">
    <div class="data-search">
      <mat-icon>search</mat-icon>
      <input type="search" [(ngModel)]="dataPaneFilter" placeholder="Search tables" aria-label="Search tables" />
    </div>

    <div class="data-browser">
      <div class="data-table-list" aria-label="Available tables">
        <button
          type="button"
          class="data-table-item"
          *ngFor="let entity of filteredExplorerEntities"
          [class.is-active]="entity === activeExplorerEntity"
          (click)="selectExplorerEntity(entity)"
          [title]="entity"
        >
          <mat-icon>table_chart</mat-icon><span>{{ entity }}</span><mat-icon>chevron_right</mat-icon>
        </button>
        <div class="data-pane-empty" *ngIf="!entitiesLoading && !filteredExplorerEntities.length">No tables found</div>
        <div class="data-pane-empty" *ngIf="entitiesLoading">Loading tables…</div>
      </div>

      <div class="data-field-list" aria-label="Table fields">
        <div class="data-field-heading" *ngIf="activeExplorerEntity" [title]="activeExplorerEntity">{{ activeExplorerEntity }}</div>
        <div class="field-search" *ngIf="activeExplorerEntity && !explorerColumnsLoading">
          <mat-icon>search</mat-icon>
          <input type="search" [(ngModel)]="fieldPaneFilter" placeholder="Search columns" aria-label="Search columns" />
          <button type="button" *ngIf="fieldPaneFilter" (click)="fieldPaneFilter = ''" aria-label="Clear column search">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="data-field-scroll">
          <div class="data-pane-empty" *ngIf="!activeExplorerEntity">Select a table to view its fields.</div>
          <div class="data-pane-empty" *ngIf="explorerColumnsLoading">Loading fields…</div>
          <div class="data-pane-empty" *ngIf="activeExplorerEntity && !explorerColumnsLoading && !filteredExplorerColumns.length">
            {{ fieldPaneFilter ? 'No matching columns' : 'No columns available' }}
          </div>
          <div
            class="data-field-item"
            *ngFor="let column of filteredExplorerColumns"
            draggable="true"
            (dragstart)="onExplorerFieldDragStart($event, activeExplorerEntity, column)"
            [title]="'Drag ' + column + ' to a bridge step'"
          >
            <mat-icon>drag_indicator</mat-icon><span>{{ column }}</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  </aside>
</section>

<!-- Interactions modal — rendered at the template ROOT (not inside a tile) so
     it's a real centered overlay, never clipped/cramped by the small tile card.
     Wires which live tiles an INPUT control drives, using its own state, so the
     left builder form/sidebar is untouched. -->
<div class="dvm-interactions-overlay" *ngIf="interactionTile" (click)="cancelTileInteractions()">
  <div class="dvm-interactions-modal" (click)="$event.stopPropagation()">
    <div class="dvm-interactions-modal-head">
      <span>Interactions — {{ interactionTile.title || (interactionTile.layoutType | titlecase) }}</span>
      <button type="button" mat-icon-button (click)="cancelTileInteractions()" aria-label="Close"><mat-icon>close</mat-icon></button>
    </div>
    <div class="dvm-interactions-modal-body">
      <div class="control-group control-group-full">
        <label>{{ interactionTileIsInput ? 'Target chart(s) / input(s) this control drives' : 'Target chart(s) / input(s) this chart interacts with' }}</label>
        <ng-select
          class="ss-select ss-select--multi ss-select--full"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="interactionTargetOptionsList"
          bindLabel="label"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [clearable]="true"
          [searchable]="true"
          placeholder="Select the chart(s)/input(s) this control drives"
          [(ngModel)]="interactionTargets"
        ></ng-select>
        <small class="control-hint" *ngIf="!interactionTargetOptionsList.length">Add more charts/inputs to the dashboard first — they'll appear here.</small>
      </div>

      <!-- Per-target formulas/references only apply to INPUT controls (they
           push a computed value into each target). A chart tile just declares
           WHICH components it interacts with — the select above is enough. -->
      <div class="control-group control-group-full" *ngFor="let id of (interactionTileIsInput ? interactionTargets : [])">
        <ng-container *ngIf="isWaterfallTarget(id)">
          <span class="target-formula-name">{{ targetLabelForId(id) }} — per bar</span>
          <div class="target-formula-bar" *ngFor="let step of targetSteps(id); trackBy: trackByStepLabel">
            <div class="target-formula-row">
              <span class="target-formula-name">{{ step.label || step.stepType }}</span>
              <input type="text" [ngModel]="interactionStepFormula(id, step.label)" (ngModelChange)="setInteractionStepFormula(id, step.label, $event)" placeholder="e.g. [price] * value" />
            </div>
            <ng-container *ngIf="formulaReferencesEnabledFor(targetLayoutTypeForId(id))">
              <ng-container *ngTemplateOutlet="interactionRefList; context: { id: id, step: step.label }"></ng-container>
            </ng-container>
          </div>
        </ng-container>
        <div *ngIf="!isWaterfallTarget(id)">
          <div class="target-formula-row">
            <span class="target-formula-name">{{ targetLabelForId(id) }}</span>
            <input type="text" [ngModel]="interactionFormulas[id] || ''" (ngModelChange)="interactionFormulas[id] = $event" [placeholder]="isInputControlTargetId(id) ? 'value (default — passes this control’s value through)' : 'e.g. [price] * value'" />
          </div>
          <!-- A CHART target with no formula is silently skipped by the
               recompute (nothing to calculate) — surface that instead. -->
          <div class="target-formula-row" *ngIf="!isInputControlTargetId(id) && !(interactionFormulas[id] || '').trim()">
            <small class="control-warning">No formula yet — "{{ targetLabelForId(id) }}" will NOT update when this control changes. Add one, e.g. [{{ targetLabelForId(id) }}]*(1+(value/100))</small>
          </div>
          <ng-container *ngIf="formulaReferencesEnabledFor(targetLayoutTypeForId(id))">
            <ng-container *ngTemplateOutlet="interactionRefList; context: { id: id }"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="dvm-interactions-modal-foot">
      <button type="button" class="add-step-button" mat-stroked-button (click)="cancelTileInteractions()">Cancel</button>
      <button type="button" class="add-step-button is-primary" mat-flat-button color="primary" (click)="saveTileInteractions()">Save</button>
    </div>
  </div>
</div>

<!-- Reference rows for the Interactions modal — its own state, separate from the
     create form's #referenceList so the two never clobber each other. -->
<ng-template #interactionRefList let-id="id" let-step="step">
  <div class="target-reference-list">
    <div class="target-reference-card" *ngFor="let ref of interactionRefs(id, step)">
      <div class="target-reference-card-header">
        <span>Reference</span>
        <button type="button" class="target-reference-remove" (click)="removeInteractionRef(id, ref)" title="Remove reference">&times;</button>
      </div>
      <div class="target-reference-grid">
        <div class="control-group"><label>Token</label><input type="text" [(ngModel)]="ref.token" placeholder="e.g. DN Price" /></div>
        <div class="control-group"><label>Input title</label><input type="text" [(ngModel)]="ref.inputTitle" placeholder="e.g. Price Inflation %" /></div>
        <div class="control-group"><label>Target label</label><input type="text" [(ngModel)]="ref.targetLabel" placeholder="e.g. Product Margins" /></div>
        <div class="control-group"><label>Row label</label><input type="text" [(ngModel)]="ref.rowLabel" placeholder="e.g. DN Price" /></div>
      </div>
    </div>
    <button type="button" class="target-reference-add" (click)="addInteractionRef(id, step)">+ Add reference</button>
  </div>
</ng-template>

